/* ═══════════════════════════════════════════════════════════
   Paceline App Portal — app-portal.js
   Handles: search (Shopify Predictive Search API), workout
   prefs, sizing prefs, activity labels for social proof title.
═══════════════════════════════════════════════════════════ */

// ── FORMAT NUMBERS ────────────────────────────────────────
// Applies locale-aware comma formatting to [data-ap-number] elements
document.querySelectorAll('[data-ap-number]').forEach(el => {
  const n = parseInt(el.dataset.apNumber, 10);
  if (!isNaN(n)) el.textContent = new Intl.NumberFormat().format(n);
});

// ── SMART REORDER ─────────────────────────────────────────
// Persistence key: { productId: { until: unixMs } }
// until = Infinity-ish (skip) or Date.now() + snooze ms
const REFILL_KEY = 'ap_refill_snooze';

function getRefillSnoozes() {
  try { return JSON.parse(localStorage.getItem(REFILL_KEY) || '{}'); }
  catch { return {}; }
}

function setRefillSnooze(productId, untilMs) {
  const data = getRefillSnoozes();
  data[productId] = { until: untilMs };
  localStorage.setItem(REFILL_KEY, JSON.stringify(data));
}

function apSnoozeRefill(productId, days, btn) {
  const untilMs = Date.now() + days * 86400 * 1000;
  setRefillSnooze(productId, untilMs);
  const card = btn.closest('.ro-card');
  if (card) {
    card.style.transition = 'opacity .3s';
    card.style.opacity = '0';
    setTimeout(() => {
      card.hidden = true;
      checkReorderSectionEmpty();
    }, 300);
  }
  console.log(`[paceline:refill] snoozed ${productId} for ${days} days`);
}

function apSkipRefill(productId, btn) {
  // Skip = snooze for 999 days (effectively permanent)
  setRefillSnooze(productId, Date.now() + 999 * 86400 * 1000);
  const card = btn.closest('.ro-card');
  if (card) {
    card.style.transition = 'opacity .3s';
    card.style.opacity = '0';
    setTimeout(() => {
      card.hidden = true;
      checkReorderSectionEmpty();
    }, 300);
  }
  console.log(`[paceline:refill] skipped ${productId}`);
}

function checkReorderSectionEmpty() {
  const sec  = document.getElementById('apReorderSec');
  const list = sec?.querySelector('.reorder-list');
  if (!list) return;
  const visible = [...list.querySelectorAll('.ro-card')].filter(c => !c.hidden);
  if (!visible.length) sec.style.display = 'none';
}

// On page load: hide any snoozed/skipped cards immediately
(function apRestoreRefillSnoozes() {
  const snoozes = getRefillSnoozes();
  const now = Date.now();
  document.querySelectorAll('.ro-card[data-product-id]').forEach(card => {
    const pid = card.dataset.productId;
    const entry = snoozes[pid];
    if (entry && now < entry.until) {
      card.hidden = true;
    }
  });
  checkReorderSectionEmpty();

// Hide reorder cards for products that are no longer active on the storefront.
// Shopify's /products/<handle>.js only serves published/active products.
(function apHideInactiveReorderCards() {
  document.querySelectorAll('.ro-card[data-product-handle]').forEach(card => {
    const handle = card.dataset.productHandle;
    if (!handle || handle === '' || handle.startsWith('demo')) return;
    fetch('/products/' + encodeURIComponent(handle) + '.js', { method: 'HEAD' })
      .then(r => {
        if (!r.ok) {
          card.style.display = 'none';
          const sec  = document.getElementById('apReorderSec');
          const list = sec && sec.querySelector('.reorder-list');
          if (list) {
            const visible = [...list.querySelectorAll('.ro-card')].filter(c => c.style.display !== 'none' && !c.hidden);
            if (!visible.length) sec.style.display = 'none';
          }
        }
      })
      .catch(() => {});
  });
})();


// Product vote persistence — intercepts cp-vote--love/cp-vote--no clicks (v3)
(function _apWireProductVotes() {
  if (document._apVoteWired) return;
  document._apVoteWired = true;
  document.addEventListener('click', function(e) {
    const btn = e.target.closest('.cp-vote--love, .cp-vote--no, .vote-btn');
    if (!btn) return;
    const isLove = btn.classList.contains('cp-vote--love') || btn.classList.contains('voted-love') ||
                   (btn.textContent || '').toLowerCase().includes('love');
    const isNo   = btn.classList.contains('cp-vote--no') || btn.classList.contains('voted-no') ||
                   (btn.textContent || '').toLowerCase().includes('not for me');
    if (!isLove && !isNo) return;
    // Walk up DOM to find [data-product-id] or [data-product]
    let productId = null;
    let el = btn;
    while (el && el.tagName !== 'BODY') {
      if (el.dataset && (el.dataset.productId || el.dataset.product || el.dataset.id)) {
        productId = el.dataset.productId || el.dataset.product || el.dataset.id;
        break;
      }
      el = el.parentElement;
    }
    // Fallback: extract product handle from a nearby /products/<handle> link
    if (!productId) {
      const card = btn.closest('[class*="card"]') || btn.parentElement?.parentElement?.parentElement;
      const link = card && (card.querySelector('a[href*="/products/"]') || card.closest('a[href*="/products/"]'));
      if (link) {
        const m = (link.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
        if (m) productId = m[1];
      }
    }
    if (!productId || String(productId).startsWith('demo')) return;
    const vote  = isLove ? 'love' : 'no';
    const card  = btn.closest('[class*="card"]');
    const title = card?.querySelector('[class*="-name"],[class*="-title"]')?.textContent?.trim() ?? '';
    const sid   = localStorage.getItem('ap_vsid') || (() => {
      const id = (crypto?.randomUUID ? crypto.randomUUID() : Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2));
      localStorage.setItem('ap_vsid', id);
      return id;
    })();
    // Read user's workout groups: server-injected prefs take priority over localStorage
    const workouts = (() => {
      try {
        const s = window.__AP_PREFS__?.prefs?.workouts;
        if (Array.isArray(s) && s.length) return s;
        const l = JSON.parse(localStorage.getItem('ap_prefs') || '{}');
        return Array.isArray(l.workouts) ? l.workouts : [];
      } catch { return []; }
    })();
    const base = (typeof window.__PACELINE_API__ !== 'undefined' ? window.__PACELINE_API__ : 'https://paceline-rye-production.up.railway.app');
    fetch(base + '/api/product-vote', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ productId: String(productId), vote, title, sessionId: sid, workouts }),
    }).catch(() => {});
  });
})();

})();

// ── WORKOUT PREFERENCES ───────────────────────────────────
// Maps pchip display text → workout tag value used on products
const workoutTagMap = {
  '🏃 Running':   'running',
  '💪 Strength':  'strength',
  '🧘 Yoga':      'yoga',
  '🤸 Pilates':   'pilates',
  '🚴 Cycling':   'cycling',
  '🏊 Swimming':  'swimming',
  '⚡ HIIT':      'hiit',
  '🥾 Hiking':    'hiking',
};

// Workout metadata for the combined WG section
const wgWorkouts = [
  { tag: 'running',  emoji: '🏃', label: 'Runners' },
  { tag: 'strength', emoji: '💪', label: 'Strength athletes' },
  { tag: 'yoga',     emoji: '🧘', label: 'Yogis' },
  { tag: 'pilates',  emoji: '🤸', label: 'Pilates people' },
  { tag: 'cycling',  emoji: '🚴', label: 'Cyclists' },
  { tag: 'swimming', emoji: '🏊', label: 'Swimmers' },
  { tag: 'hiit',     emoji: '⚡', label: 'HIIT athletes' },
  { tag: 'hiking',   emoji: '🥾', label: 'Hikers' },
];

// Reason lines — observational framing, only shown when product is exclusively
// tagged for exactly one workout (multi-tagged = general item, suppress reason)
const workoutReasonMap = {
  'running':  'Runners are loving this',
  'strength': 'A strength training staple',
  'yoga':     'Yoga community favorite',
  'pilates':  'Popular with pilates athletes',
  'cycling':  'Cyclists are loving this',
  'swimming': "A swimmers' top pick",
  'hiit':     'Top pick for HIIT training',
  'hiking':   "Hikers' top pick this season",
};

let wgActiveTag   = null;
let wgActiveLevel = 'all';

// Products whose type signals they don't belong in a workout context.
// If a card's data-product-type matches the regex for the active workout,
// it's hidden (e.g. running shoes for Yogis).
const wgTypeBlocklist = {
  'yoga':     /shoe|sneaker|trail|footwear|boot|cleat/i,
  'pilates':  /shoe|sneaker|trail|footwear|boot|cleat/i,
  'swimming': /shoe|sneaker|trail|footwear|boot|cleat/i,
  // running, strength, cycling, hiking, hiit — no blocklist
};

function apWgInit() {
  const grid = document.getElementById('apWgGrid');
  if (!grid) return;

  // 1. Find workout tags that have ≥1 product in grid
  const cards    = [...grid.querySelectorAll('.wg-card[data-workouts]')];
  const available = new Set();
  cards.forEach(c => {
    (c.dataset.workouts || '').split(',').forEach(t => { if (t.trim()) available.add(t.trim()); });
  });
  if (!available.size) return;

  // 2. Prefer user's saved workouts (from server-injected __AP_PREFS__)
  const savedWorkouts = (window.__AP_PREFS__?.prefs?.workouts || [])
    .map(w => workoutTagMap[w]).filter(Boolean);
  const pool = savedWorkouts.filter(t => available.has(t));
  const usePool = pool.length ? pool : [...available];

  // 3. Rotate via sessionStorage so each page load shows a different workout
  let idx = 0;
  try {
    const stored = parseInt(sessionStorage.getItem('wgRotIdx') || '-1', 10);
    idx = (stored + 1) % usePool.length;
    sessionStorage.setItem('wgRotIdx', String(idx));
  } catch(e) {}

  wgActiveTag = usePool[idx];
  apWgFilter();
}

function apWgFilter() {
  const grid  = document.getElementById('apWgGrid');
  if (!grid) return;
  const empty = document.getElementById('apWgEmpty');
  const cards = [...grid.querySelectorAll('.wg-card[data-workouts]')];

  // Update title display
  const wo      = wgWorkouts.find(w => w.tag === wgActiveTag);
  const emojiEl = document.getElementById('wgEmojiDisplay');
  const labelEl = document.getElementById('wgWorkoutDisplay');
  if (emojiEl && wo) emojiEl.textContent = wo.emoji;
  if (labelEl && wo) labelEl.textContent = wo.label;

  // Mark active item in picker
  document.querySelectorAll('.wg-picker-item').forEach(item => {
    item.classList.toggle('active', item.dataset.tag === wgActiveTag);
  });

  let shown = 0;
  cards.forEach(card => {
    const cardTags     = new Set((card.dataset.workouts || '').split(',').map(s => s.trim()));
    const matchesWo    = !wgActiveTag || cardTags.has(wgActiveTag);
    const cardLevel    = card.dataset.level || '';
    const matchesLevel = wgActiveLevel === 'all' || cardLevel === wgActiveLevel;
    // Block product types that don't fit the workout (e.g. shoes for Yogis)
    const productType  = card.dataset.productType || '';
    const typeBlock    = wgActiveTag && wgTypeBlocklist[wgActiveTag];
    const typeOk       = !typeBlock || !typeBlock.test(productType);
    const visible      = matchesWo && matchesLevel && typeOk;
    card.hidden        = !visible;

    if (visible) {
      shown++;
      const reasonEl = card.querySelector('.wg-reason');
      if (reasonEl) {
        const wkCount = parseInt(card.dataset.workoutCount || '1', 10);
        const reason  = wkCount === 1 ? (workoutReasonMap[wgActiveTag] ?? '') : '';
        reasonEl.textContent   = reason;
        reasonEl.style.display = reason ? '' : 'none';
      }
    } else {
      const reasonEl = card.querySelector('.wg-reason');
      if (reasonEl) reasonEl.style.display = 'none';
    }
  });

  grid.style.display  = shown ? '' : 'none';
  if (empty) empty.style.display = shown ? 'none' : '';
}

function apWgSwitch(tag) {
  wgActiveTag = tag;
  apWgClosePicker();
  apWgFilter();
}

function apWgSetLevel(btn, level) {
  document.querySelectorAll('.wg-level').forEach(b => b.classList.remove('on'));
  btn.classList.add('on');
  wgActiveLevel = level;
  apWgFilter();
}

function apWgOpenPicker(e) {
  if (e) e.stopPropagation();
  document.getElementById('apWgPicker')?.classList.toggle('open');
}

function apWgClosePicker() {
  document.getElementById('apWgPicker')?.classList.remove('open');
}

// Close picker on outside click
document.addEventListener('click', e => {
  if (!e.target.closest('#wgWorkoutBtn') && !e.target.closest('#apWgPicker')) {
    apWgClosePicker();
  }
});

// Boot WG section
apWgInit();

function updateWorkoutSaveBtn() {
  const btn = document.getElementById('apWorkoutSaveBtn');
  if (!btn) return;
  btn.disabled = !document.querySelector('.pchip.on');
}

document.querySelectorAll('.pchip').forEach(chip => {
  chip.addEventListener('click', function () {
    this.classList.toggle('on');
    updateWorkoutSaveBtn();
  });
});

// Init button state (disabled since nothing pre-selected)
updateWorkoutSaveBtn();

async function apSaveWorkoutPrefs(btn) {
  const selected = [...document.querySelectorAll('.pchip.on')]
    .map(c => c.textContent.trim());
  if (!selected.length) return;

  await apSavePrefs({ workouts: selected });

  const summaryEl = document.getElementById('apWorkoutSummary');
  if (summaryEl) summaryEl.textContent = selected.join(' · ');
  document.getElementById('apWorkoutCard').style.display = 'none';
  document.getElementById('apWorkoutSaved').style.display = '';
}

// ── SIZE-BASED FILTERING ──────────────────────────────────
// Reads saved sizing prefs from window.__AP_PREFS__ and hides
// kit/wg cards where no in-stock variant matches the user's sizes.
// Handles shoe size gender ambiguity: M9/9M = men's, W9/9W = women's,
// plain 9 → fallback to product title gender check.

function _apNormalizeShoeSize(raw) {
  if (!raw) return null;
  const s = String(raw).toLowerCase().trim();
  let gender = null, num = s;
  if (/^m[\d.]+$/.test(s))  { gender = 'm'; num = s.slice(1); }
  else if (/^w[\d.]+$/.test(s))  { gender = 'w'; num = s.slice(1); }
  else if (/^[\d.]+m$/.test(s))  { gender = 'm'; num = s.slice(0, -1); }
  else if (/^[\d.]+w$/.test(s))  { gender = 'w'; num = s.slice(0, -1); }
  return { num, gender };
}

function _apShoeMatches(variantSz, savedShoe, userAud, productTitle) {
  const saved   = _apNormalizeShoeSize(savedShoe);
  const variant = _apNormalizeShoeSize(variantSz);
  if (!saved || !variant) return false;
  if (variant.num !== saved.num) return false;           // different number

  const isMens   = userAud.includes('mens');
  const isWomens = userAud.includes('womens');

  if (variant.gender === 'm') return isMens || (!isMens && !isWomens);
  if (variant.gender === 'w') return isWomens || (!isMens && !isWomens);

  // Plain numeric — inspect product title for gender signal
  const lcTitle     = (productTitle || '').toLowerCase();
  const titleWomens = /\bwomen'?s?\b/.test(lcTitle);
  const titleMens   = /\bmen'?s?\b/.test(lcTitle) && !titleWomens;
  if (titleMens   && isWomens && !isMens)   return false;  // men's shoe, women's user
  if (titleWomens && isMens   && !isWomens) return false;  // women's shoe, men's user
  return true;
}

function apFilterBySize() {
  const sizing = window.__AP_PREFS__?.prefs?.sizing;
  if (!sizing) return;

  const savedShoe = sizing.shoe;
  const savedTop  = sizing.top;
  const savedPant = sizing.pant;
  const userAud   = (sizing.audience || []).map(a => String(a).toLowerCase());

  if (!savedShoe && !savedTop && !savedPant) return;  // nothing saved yet

  document.querySelectorAll(
    '.kit-pcard[data-sizes], .wg-card[data-sizes]'
  ).forEach(card => {
    const sizes = (card.dataset.sizes || '').split('|').filter(Boolean);
    if (!sizes.length) return;  // no variant info → don't hide (accessory, one-size)

    const productTitle = card.dataset.productTitle || '';

    // Detect product type by variant option format
    const isShoe    = sizes.some(s => /^[mw]?[\d.]+[mw]?$/.test(s.trim()));
    const isApparel = sizes.some(s => /^(xs|s|m|l|xl|2?xl|3?xl|\d{1,2})$/i.test(s.trim())) && !isShoe;

    let matches = true;

    if (isShoe && savedShoe) {
      matches = sizes.some(s => _apShoeMatches(s.trim(), savedShoe, userAud, productTitle));
    } else if (isApparel) {
      // Try top first, then pant
      const wantSize = savedTop || savedPant;
      if (wantSize) {
        matches = sizes.some(s => s.toLowerCase() === wantSize.toLowerCase());
      }
    }

    if (!matches) card.hidden = true;
  });
}

apFilterBySize();

// ── AUDIENCE / SIZING PREFS ───────────────────────────────
function toggleAudience(el) {
  el.classList.toggle('on');
}

async function apSaveSizing(btn) {
  const audience   = [...document.querySelectorAll('.audience-chip.on')]
    .map(c => c.dataset.aud);
  const shoe       = document.querySelector('.size-group[data-size="shoe"] .schip.on')?.textContent.trim();
  const shoe_width = document.querySelector('.size-group[data-size="shoe_width"] .schip.on')?.textContent.trim();
  const top        = document.querySelector('.size-group[data-size="top"] .schip.on')?.textContent.trim();
  const pant       = document.querySelector('.size-group[data-size="pant"] .schip.on')?.textContent.trim();

  const parts = [];
  if (audience.length) parts.push(audience.map(a => a === 'mens' ? "Men's apparel" : "Women's apparel").join(' & '));
  if (shoe)       parts.push(`Shoe ${shoe}${shoe_width ? ' ' + shoe_width : ''}`);
  if (top)        parts.push(`Top ${top}`);
  if (pant)       parts.push(`Pant ${pant}`);

  const summary = parts.join(' · ');
  document.getElementById('apSizingSummary').textContent = summary || 'No preferences set';
  document.getElementById('apSizingForm').style.display = 'none';
  document.getElementById('apSizingSaved').style.display = '';

  // Save via unified prefs proxy (also writes to localStorage inside apSavePrefs)
  const savedAt = new Date().toISOString();
  const sizingData = { shoe, shoe_width, top, pant, audience, savedAt };
  await apSavePrefs({ sizing: sizingData });

  // Keep ap_sizing for flash-picks.js compatibility
  try { localStorage.setItem('ap_sizing', JSON.stringify({ ...sizingData, savedAt: new Date().toISOString() })); } catch(e){}

  // Reload flash picks with new sizing
  const fpGrid = document.getElementById('apFlashPicksGrid');
  if (fpGrid && window.apFlashPicks) window.apFlashPicks.load(fpGrid);
}

// ── SEARCH — Shopify Predictive Search API ────────────────
function apOpenSearch() {
  document.getElementById('apSearchModal').classList.add('open');
  document.body.style.overflow = 'hidden';
  setTimeout(() => document.getElementById('apSearchInput')?.focus(), 280);
}

function apCloseSearch() {
  document.getElementById('apSearchModal').classList.remove('open');
  document.body.style.overflow = '';
  const input = document.getElementById('apSearchInput');
  if (input) input.value = '';
  apResetSearch();
}

function apResetSearch() {
  const empty   = document.getElementById('apSearchEmpty');
  const results = document.getElementById('apSearchResults');
  if (empty)   empty.style.display   = '';
  if (results) { results.style.display = 'none'; results.innerHTML = ''; }
}

let _apSearchTimer;
const apSearchInput = document.getElementById('apSearchInput');
if (apSearchInput) {
  apSearchInput.addEventListener('input', function () {
    clearTimeout(_apSearchTimer);
    const q = this.value.trim();
    if (!q) { apResetSearch(); return; }
    _apSearchTimer = setTimeout(() => apRunSearch(q), 200);
  });
}

function apDoSearch(q) {
  const input = document.getElementById('apSearchInput');
  if (input) input.value = q;
  apRunSearch(q);
}

async function apRunSearch(q) {
  const empty   = document.getElementById('apSearchEmpty');
  const results = document.getElementById('apSearchResults');
  if (!results) return;

  if (empty)   empty.style.display   = 'none';
  results.style.display = '';
  results.innerHTML = '<div class="sr-section-label" style="opacity:.5">Searching…</div>';

  // Log search for analytics
  console.log('[paceline:search]', q);

  const url = `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last`;

  try {
    const r = await fetch(url);
    const data = await r.json();
    const products = data?.resources?.results?.products ?? [];

    // Fetch actual Pacepoints discount data so we can show real pricing.
    // The Predictive Search API only returns a formatted price string — no metafields.
    let discountMeta = {};
    if (products.length) {
      const ids = products.map(p => {
        const m = String(p.id ?? '').match(/(\d+)$/);
        return m ? m[1] : String(p.id ?? '');
      }).filter(Boolean).join(',');
      try {
        const dm = await fetch(
          `https://paceline-rye-production.up.railway.app/api/product-discount-meta?ids=${ids}`
        );
        if (dm.ok) discountMeta = await dm.json();
      } catch (_) { /* discount meta is best-effort */ }
    }

    apRenderResults(products, q, discountMeta);
  } catch {
    results.innerHTML = '<div class="sr-section-label" style="color:var(--ap-paprika)">Search unavailable — try again.</div>';
  }
}

function apRenderResults(products, q, discountMeta) {
  discountMeta = discountMeta || {};
  const results = document.getElementById('apSearchResults');
  if (!results) return;

  if (!products.length) {
    results.innerHTML = `
      <div class="search-zero">
        <div class="sz-emoji">🔭</div>
        <div class="sz-title">Nothing in the catalog yet for "${q}"</div>
        <div class="sz-sub">We don't carry that yet. If enough members want it, we'll add it — your vote helps us decide what to source next.</div>
        <button class="sz-vote" onclick="apVoteForProduct('${q.replace(/'/g, "\\'")}')">\u{1F44D} Vote to add "${q}"</button>
      </div>`;
    return;
  }

  results.innerHTML = `
    <div class="sr-section-label">${products.length} result${products.length === 1 ? '' : 's'} for "${q}"</div>
    ${products.map(p => {
      const img = p.featured_image?.url ?? '';
      const imgTag = img
        ? `<div class="sr-ico"><img src="${img}&width=80" alt="${p.title}" loading="lazy"></div>`
        : `<div class="sr-ico">🛍️</div>`;

      // Extract numeric product ID (supports "gid://shopify/Product/123" or plain number)
      const pid = String(p.id ?? '').match(/(\d+)$/)?.[1] ?? String(p.id ?? '');
      const disc = discountMeta[pid];

      let priceRow;
      if (disc && disc.pct > 0 && disc.cost > 0) {
        // p.price is the already-formatted original price from Shopify's predictive search
        // (e.g. "$36.00"). Use it directly as the crossed-out MSRP, and compute the
        // discounted amount from the percentage to avoid any cents/dollars ambiguity.
        const origNum = parseFloat((p.price ?? '0').replace(/[^0-9.]/g, '')) || 0;
        const discNum = origNum > 0 ? origNum * (1 - disc.pct / 100) : 0;
        const fmt = n => '$' + n.toFixed(2).replace(/\.00$/, '');
        priceRow = `<span class="sr-price-orig">${p.price}</span>`
                 + `<span class="sr-price-disc">${fmt(discNum)}</span>`
                 + `<span class="sr-pp-badge">with ${disc.cost.toLocaleString()} Pacepoints</span>`;
      } else if (p.price) {
        priceRow = `<span class="sr-price-plain">${p.price}</span>`;
      } else {
        priceRow = '';
      }

      return `
        <a href="${p.url}" class="sr-item">
          ${imgTag}
          <div style="flex:1;min-width:0;">
            <div class="sr-brand">${p.vendor ?? ''}</div>
            <div class="sr-name">${p.title}</div>
            <div class="sr-price-row">${priceRow}</div>
          </div>
        </a>`;
    }).join('')}`;
}


// ── CUSTOMER PREFERENCES — unified proxy-backed store ────────────────────────
// Single endpoint, single metafield (paceline-backend.portal_preferences).
// Shape: { workouts, sizing, seasonal: { optins, dismissed }, votes }
// Server state injected by Liquid as window.__AP_PREFS__ at page load.
// localStorage is used as optimistic cache + logged-out fallback.
const AP_PREFS_URL = 'https://paceline-rye-production.up.railway.app/api/portal-prefs';
if (!window.__AP_PREFS__) {
  var _lp = null;
  try {
    var _raw = localStorage.getItem('ap_prefs');
    if (_raw) {
      _lp = JSON.parse(_raw);
      // Detect corrupted entry: a spread string produces {0:'{',1:'"',...} with no workouts key
      if (_lp && typeof _lp === 'object' && !Array.isArray(_lp) && '0' in _lp && !('workouts' in _lp)) {
        _lp = null;
        localStorage.removeItem('ap_prefs');
      }
    }
  } catch(e) {}
  var _cid = window.Shopify && window.Shopify.customer && window.Shopify.customer.id;
  if (_lp || _cid) {
    window.__AP_PREFS__ = { isLoggedIn: !!_cid, customerId: _cid ? String(_cid) : null, prefs: _lp };
  }
}
if (window.__AP_PREFS__ && typeof window.__AP_PREFS__.prefs === 'string') {
  try { window.__AP_PREFS__.prefs = JSON.parse(window.__AP_PREFS__.prefs); } catch(e) {}
}
// Sync Liquid-injected prefs → localStorage so kits/flash portals can read them without Liquid
if (window.__AP_PREFS__ && window.__AP_PREFS__.prefs && !localStorage.getItem('ap_prefs')) {
  try { localStorage.setItem('ap_prefs', JSON.stringify(window.__AP_PREFS__.prefs)); } catch(e) {}
}
// Re-run init functions that ran before bootstrap (apWgInit at L325, apFilterBySize at L433)
// On kits/flash portals those ran with __AP_PREFS__ undefined; re-run now that it's set.
if (typeof apWgInit === 'function') apWgInit();
if (typeof apFilterBySize === 'function') apFilterBySize();
// Pre-select .pchip workout chips and hide the picker card if prefs are already saved.
// On app-portal Liquid already does this; on kits/flash portals JS must do it.
(function() {
  var wk = window.__AP_PREFS__ && window.__AP_PREFS__.prefs && window.__AP_PREFS__.prefs.workouts;
  if (!Array.isArray(wk) || !wk.length) return;
  document.querySelectorAll('.pchip').forEach(function(chip) {
    if (wk.indexOf(chip.textContent.trim()) >= 0) chip.classList.add('on');
  });
  if (typeof updateWorkoutSaveBtn === 'function') updateWorkoutSaveBtn();
  var card    = document.getElementById('apWorkoutCard');
  var savedEl = document.getElementById('apWorkoutSaved');
  var summary = document.getElementById('apWorkoutSummary');
  if (card && card.style.display !== 'none') {
    card.style.display    = 'none';
    if (savedEl) savedEl.style.display = '';
    if (summary) summary.textContent   = wk.join(' · ');
  }
})();
if (!window.__AP_PREFS__) {
  var _lp = null;
  try {
    var _raw = localStorage.getItem('ap_prefs');
    if (_raw) {
      _lp = JSON.parse(_raw);
      // Detect corrupted entry: a spread string produces {0:'{',1:'"',...} with no workouts key
      if (_lp && typeof _lp === 'object' && !Array.isArray(_lp) && '0' in _lp && !('workouts' in _lp)) {
        _lp = null;
        localStorage.removeItem('ap_prefs');
      }
    }
  } catch(e) {}
  var _cid = window.Shopify && window.Shopify.customer && window.Shopify.customer.id;
  if (_lp || _cid) {
    window.__AP_PREFS__ = { isLoggedIn: !!_cid, customerId: _cid ? String(_cid) : null, prefs: _lp };
  }
}
if (window.__AP_PREFS__ && typeof window.__AP_PREFS__.prefs === 'string') {
  try { window.__AP_PREFS__.prefs = JSON.parse(window.__AP_PREFS__.prefs); } catch(e) {}
}
// Sync Liquid-injected prefs → localStorage so kits/flash portals can read them without Liquid
if (window.__AP_PREFS__ && window.__AP_PREFS__.prefs && !localStorage.getItem('ap_prefs')) {
  try { localStorage.setItem('ap_prefs', JSON.stringify(window.__AP_PREFS__.prefs)); } catch(e) {}
}
if (!window.__AP_PREFS__) {
  var _lp = null;
  try {
    var _raw = localStorage.getItem('ap_prefs');
    if (_raw) {
      _lp = JSON.parse(_raw);
      // Detect corrupted entry: a spread string produces {0:'{',1:'"',...} with no workouts key
      if (_lp && typeof _lp === 'object' && !Array.isArray(_lp) && '0' in _lp && !('workouts' in _lp)) {
        _lp = null;
        localStorage.removeItem('ap_prefs');
      }
    }
  } catch(e) {}
  var _cid = window.Shopify && window.Shopify.customer && window.Shopify.customer.id;
  if (_lp || _cid) {
    window.__AP_PREFS__ = { isLoggedIn: !!_cid, customerId: _cid ? String(_cid) : null, prefs: _lp };
  }
}
if (window.__AP_PREFS__ && typeof window.__AP_PREFS__.prefs === 'string') {
  try { window.__AP_PREFS__.prefs = JSON.parse(window.__AP_PREFS__.prefs); } catch(e) {}
}
// Sync Liquid-injected prefs → localStorage so kits/flash portals can read them without Liquid
if (window.__AP_PREFS__ && window.__AP_PREFS__.prefs && !localStorage.getItem('ap_prefs')) {
  try { localStorage.setItem('ap_prefs', JSON.stringify(window.__AP_PREFS__.prefs)); } catch(e) {}
}
if (!window.__AP_PREFS__) {
  var _lp = null;
  try {
    var _raw = localStorage.getItem('ap_prefs');
    if (_raw) {
      _lp = JSON.parse(_raw);
      // Detect corrupted entry: a spread string produces {0:'{',1:'"',...} with no workouts key
      if (_lp && typeof _lp === 'object' && !Array.isArray(_lp) && '0' in _lp && !('workouts' in _lp)) {
        _lp = null;
        localStorage.removeItem('ap_prefs');
      }
    }
  } catch(e) {}
  var _cid = window.Shopify && window.Shopify.customer && window.Shopify.customer.id;
  if (_lp || _cid) {
    window.__AP_PREFS__ = { isLoggedIn: !!_cid, customerId: _cid ? String(_cid) : null, prefs: _lp };
  }
}
if (window.__AP_PREFS__ && typeof window.__AP_PREFS__.prefs === 'string') {
  try { window.__AP_PREFS__.prefs = JSON.parse(window.__AP_PREFS__.prefs); } catch(e) {}
}
if (!window.__AP_PREFS__) {
  var _lp = null;
  try { _lp = JSON.parse(localStorage.getItem('ap_prefs') || 'null'); } catch(e) {}
  var _cid = window.Shopify && window.Shopify.customer && window.Shopify.customer.id;
  if (_lp || _cid) {
    window.__AP_PREFS__ = { isLoggedIn: !!_cid, customerId: _cid ? String(_cid) : null, prefs: _lp };
  }
}
if (window.__AP_PREFS__ && typeof window.__AP_PREFS__.prefs === 'string') {
  try { window.__AP_PREFS__.prefs = JSON.parse(window.__AP_PREFS__.prefs); } catch(e) {}
}
if (window.__AP_PREFS__ && typeof window.__AP_PREFS__.prefs === 'string') {
  try { window.__AP_PREFS__.prefs = JSON.parse(window.__AP_PREFS__.prefs); } catch(e) {}
}

function _apIsLoggedIn() {
  return !!(window.__AP_PREFS__ || {}).isLoggedIn
    || !!(window.Shopify && window.Shopify.customer && window.Shopify.customer.id);
}

function _apCustomerId() {
  return (window.__AP_PREFS__ || {}).customerId
    ?? (window.Shopify && window.Shopify.customer
        ? String(window.Shopify.customer.id) : null)
    ?? null;
}

// Deep-merge helper (plain objects only — arrays are replaced)
function _apMerge(base, patch) {
  const out = { ...base };
  for (const [k, v] of Object.entries(patch || {})) {
    if (v && typeof v === 'object' && !Array.isArray(v) &&
        out[k] && typeof out[k] === 'object' && !Array.isArray(out[k])) {
      out[k] = _apMerge(out[k], v);
    } else {
      out[k] = v;
    }
  }
  return out;
}

// Read full merged prefs: server wins for logged-in, localStorage as fallback
function apGetPrefs() {
  const server = (window.__AP_PREFS__ || {}).prefs || {};
  let local = {};
  try { local = JSON.parse(localStorage.getItem('ap_prefs') || '{}'); } catch(e){}
  return _apIsLoggedIn() ? _apMerge(local, server) : local;
}

// Union-merge vote arrays by pid so voting on a second product doesn't
// erase the first. Both love and no are treated as append-only sets.
function _apMergeVotes(current, patch) {
  const getPid = e => (typeof e === 'object' ? e.pid : e);
  const merged = { ...current };
  for (const key of ['love', 'no']) {
    if (!Array.isArray(patch[key])) continue;
    const existing = Array.isArray(current[key]) ? current[key] : [];
    const existingPids = new Set(existing.map(getPid));
    const toAdd = patch[key].filter(e => !existingPids.has(getPid(e)));
    merged[key] = [...existing, ...toAdd];
  }
  return merged;
}

// Persist patch to localStorage and fire-and-forget to proxy
async function apSavePrefs(patch) {
  // Block server writes in admin preview mode — protects the real customer's prefs
  try { if (sessionStorage.getItem('ap_preview_active') === '1') return; } catch {}
  const current = apGetPrefs();

  // Special case: votes.love / votes.no are union-appended, not replaced
  let patchForMerge = patch;
  if (patch.votes && current.votes) {
    patchForMerge = { ...patch, votes: _apMergeVotes(current.votes, patch.votes) };
  }

  const merged = _apMerge(current, patchForMerge);
  try { localStorage.setItem('ap_prefs', JSON.stringify(merged)); } catch(e){}
  const customerId = _apCustomerId();
  if (_apIsLoggedIn() && customerId) {
    console.log('[paceline] saving prefs for customer', customerId, patch);
    fetch(AP_PREFS_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ customerId, ...patch }),
    })
    .then(r => r.json().then(body => {
      if (!r.ok) console.error('[paceline] prefs save error', r.status, body);
      else console.log('[paceline] prefs saved OK:', body);
    }))
    .catch(err => console.warn('[paceline] prefs save failed (localStorage preserved):', err));
  } else {
    console.log('[paceline] not logged in or no customerId — localStorage only. __AP_PREFS__:', window.__AP_PREFS__);
  }
  return merged;
}

// ── SEASONAL (tier 2 opt-in — Yes / No per occasion) ─────────────────────

function _apDismissAskCard(season) {
  const card = document.getElementById('apSeasonalAsk_' + season);
  if (!card) return;
  card.style.transition = 'opacity .2s';
  card.style.opacity = '0';
  setTimeout(() => { card.style.display = 'none'; }, 210);
}

async function apSeasonalYes(season) {
  _apDismissAskCard(season);
  const strip = document.querySelector('.seasonal-strip[data-season="' + season + '"]');
  if (strip) strip.style.display = '';
  await apSavePrefs({ seasonal: { optins: { [season]: true } } });
}

async function apSeasonalNo(season) {
  _apDismissAskCard(season);
  await apSavePrefs({ seasonal: { dismissed: { [season]: true } } });
}

function apApplyOptinStrips(optins, dismissed) {
  dismissed = dismissed || {};
  // Show strips for opted-in occasions
  document.querySelectorAll('.seasonal-strip[data-season]').forEach(strip => {
    strip.style.display = (optins && optins[strip.dataset.season]) ? '' : 'none';
  });
  // Hide ask-cards for already-answered occasions (opted in OR dismissed)
  document.querySelectorAll('.so-ask-card[data-season]').forEach(card => {
    const s = card.dataset.season;
    if ((optins && optins[s]) || dismissed[s]) card.style.display = 'none';
  });
}

// ── SEASONAL (tier 1 auto-show dismiss) ──────────────────
async function apDismissAutoEvent(key) {
  const strip = document.querySelector(`.seasonal-auto[data-dismiss-key="${key}"]`);
  if (strip) {
    strip.style.transition = 'opacity .2s';
    strip.style.opacity = '0';
    setTimeout(() => strip.style.display = 'none', 200);
  }
  await apSavePrefs({ seasonal: { dismissed: { [key]: true } } });
}

// ── RESTORE ALL PREFS ON LOAD ────────────────────────────
(function apRestoreAllPrefs() {
  const prefs = apGetPrefs();

  // Seasonal opt-in strips + hide already-answered ask cards
  apApplyOptinStrips(prefs.seasonal?.optins || {}, prefs.seasonal?.dismissed || {});

  // Auto-show dismissals (data-dismiss-key uses camelCase in JS dataset)
  document.querySelectorAll('.seasonal-auto[data-dismiss-key]').forEach(strip => {
    const key = strip.dataset.dismissKey;   // camelCase from dataset
    // also check raw attribute in case dataset conversion differs
    const rawKey = strip.getAttribute('data-dismiss-key');
    const dismissed = prefs.seasonal?.dismissed || {};
    if (dismissed[key] || dismissed[rawKey]) strip.style.display = 'none';
  });

  // Workout chips
  const savedWorkouts = prefs.workouts || [];
  if (savedWorkouts.length) {
    document.querySelectorAll('.pchip').forEach(chip => {
      if (savedWorkouts.includes(chip.textContent.trim())) chip.classList.add('on');
    });
    // Show saved state card
    const summaryEl = document.getElementById('apWorkoutSummary');
    if (summaryEl) summaryEl.innerHTML = savedWorkouts
        .map(w => w.replace('🥊 HIIT', '⚡ HIIT')) // normalise legacy stored emoji
        .map(w => `<span style="white-space:nowrap">${w}</span>`)
        .join('<span style="color:var(--ap-border)"> · </span>');
    const card   = document.getElementById('apWorkoutCard');
    const saved  = document.getElementById('apWorkoutSaved');
    if (card && saved) { card.style.display = 'none'; saved.style.display = ''; }
    // WG section re-init after prefs load so it can pick the right workout
    apWgInit();
  }

  // Sizing
  const sz = prefs.sizing;
  if (sz) {
    if (sz.audience?.length) {
      document.querySelectorAll('.audience-chip').forEach(c => {
        if (sz.audience.includes(c.dataset.aud)) c.classList.add('on');
      });
    }
    const matchChip = (selector, val) => {
      if (!val) return;
      document.querySelector(selector)?.querySelectorAll('.schip').forEach(c => {
        if (c.textContent.trim() === val) c.classList.add('on');
      });
    };
    matchChip('.size-group[data-size="shoe"]',       sz.shoe);
    matchChip('.size-group[data-size="shoe_width"]', sz.shoe_width);
    matchChip('.size-group[data-size="top"]',        sz.top);
    matchChip('.size-group[data-size="pant"]',       sz.pant);
    // Collapse to saved state
    const parts = [];
    if (sz.audience?.length) parts.push(sz.audience.map(a => a === 'mens' ? "Men's" : "Women's").join(' & '));
    if (sz.shoe) parts.push(`Shoe ${sz.shoe}${sz.shoe_width ? ' ' + sz.shoe_width : ''}`);
    if (sz.top)  parts.push(`Top ${sz.top}`);
    if (sz.pant) parts.push(`Pant ${sz.pant}`);
    const summaryEl = document.getElementById('apSizingSummary');
    if (summaryEl && parts.length) summaryEl.textContent = parts.join(' · ');
    const form  = document.getElementById('apSizingForm');
    const saved = document.getElementById('apSizingSaved');
    if (form && saved && parts.length) { form.style.display = 'none'; saved.style.display = ''; }
    // Sync ap_sizing to localStorage for flash-picks.js.
    // Prefer whichever copy is more recent — prevents a stale metafield from
    // overwriting a just-saved local preference on a quick page refresh.
    try {
      const localRaw = localStorage.getItem('ap_sizing');
      const localSz  = localRaw ? JSON.parse(localRaw) : null;
      const serverTs = new Date(sz.savedAt    || 0).getTime();
      const localTs  = new Date(localSz?.savedAt || 0).getTime();
      localStorage.setItem('ap_sizing', JSON.stringify(localTs > serverTs ? localSz : sz));
    } catch(e) {}
  }
})();

// ── COMMUNITY CORNER POLL ────────────────────────────────
// localStorage shape: { [pollId]: { date: 'YYYY-MM-DD', choice: 'label', sessionId: 'xxx' } }
const POLL_VOTE_KEY    = 'ap_poll_vote';
const POLL_VOTE_API    = 'https://paceline-rye-production.up.railway.app/api/poll-vote';

function _pollToday() {
  return new Date().toISOString().slice(0, 10);
}

function _pollSessionId() {
  try {
    let sid = localStorage.getItem('ap_session_id');
    if (!sid) {
      sid = Math.random().toString(36).slice(2, 11) + Date.now().toString(36);
      localStorage.setItem('ap_session_id', sid);
    }
    return sid;
  } catch { return 'anon'; }
}

function _pollGetTodayVote(pollId) {
  try {
    const data = JSON.parse(localStorage.getItem(POLL_VOTE_KEY) || '{}');
    const entry = data[pollId];
    return entry?.date === _pollToday() ? entry.choice : null;
  } catch { return null; }
}

function _pollSaveVote(pollId, choice) {
  try {
    const data = JSON.parse(localStorage.getItem(POLL_VOTE_KEY) || '{}');
    data[pollId] = { date: _pollToday(), choice, sessionId: _pollSessionId() };
    localStorage.setItem(POLL_VOTE_KEY, JSON.stringify(data));
  } catch {}
}

// Recalculate and render updated percentages after adding 1 vote to votedOpt.
// Uses the existing data-pct values as a baseline (admin keeps them current).
function _pollRevealResults(opts, votedOpt, markFooter) {
  // Mark the container as voted so CSS reveals the bar-wrap elements
  const optsEl = document.getElementById('apCommPollOpts');
  if (optsEl) optsEl.classList.add('voted');

  const pcts      = [...opts].map(o => parseFloat(o.dataset.pct) || 0);
  const baseTotal = pcts.reduce((a, b) => a + b, 0); // existing votes represented as %
  const votedIdx  = [...opts].indexOf(votedOpt);

  // Compute raw counts from percentages (assume baseTotal% represents baseTotal votes
  // when total is unknown — treat percentages as vote counts directly, +1 for user's vote)
  const rawCounts  = pcts.map((p, i) => p + (i === votedIdx ? 1 : 0));
  const rawTotal   = rawCounts.reduce((a, b) => a + b, 0);

  opts.forEach((o, i) => {
    const newPct = rawTotal > 0 ? Math.round((rawCounts[i] / rawTotal) * 100) : (i === votedIdx ? 100 : 0);
    const fill = o.querySelector('.comm-poll-fill');
    const pct  = o.querySelector('.comm-poll-pct');
    if (fill) fill.style.transition = 'width .5s ease';
    if (fill) fill.style.width      = newPct + '%';
    if (pct)  pct.textContent       = newPct + '%';
  });

  if (!markFooter) return;

  const foot = document.getElementById('apCommPollFoot');
  if (!foot) return;

  const showCount = foot.dataset.showCount === '1';
  foot.style.display = '';

  foot.textContent = 'Thanks for voting!';
}

function apCommPollVote(opt) {
  const optsEl = document.getElementById('apCommPollOpts');
  const opts   = optsEl ? optsEl.querySelectorAll('.comm-poll-opt') : [];

  // Block if already voted this page session
  if ([...opts].some(o => o.classList.contains('on'))) return;

  const pollId = optsEl?.dataset.pollId || 'default';

  // Block if already voted today (once-per-day limit)
  if (_pollGetTodayVote(pollId)) return;

  const choice    = opt.dataset.label || opt.querySelector('.comm-poll-label')?.textContent?.trim() || '';
  const sessionId = _pollSessionId();

  // Mark the chosen option
  opt.classList.add('on');
  const checkEl = opt.querySelector('.comm-poll-check');
  if (checkEl) checkEl.textContent = '✓';

  // Save to localStorage (prevents second vote today)
  _pollSaveVote(pollId, choice);

  // Show updated percentages + footer
  _pollRevealResults(opts, opt, true);

  // POST to backend, then immediately fetch live results and replace optimistic UI
  const customerId = window.__AP_PREFS__?.customerId ?? null;
  fetch(POLL_VOTE_API, {
    method:  'POST',
    headers: { 'Content-Type': 'application/json' },
    body:    JSON.stringify({ pollId, choice, sessionId, customerId }),
  })
  .then(() => _pollFetchAndApplyResults(optsEl, pollId))
  .catch(() => {});

  console.log('[paceline:community-poll] voted:', choice, '| poll:', pollId);
}

// ── Fetch live poll results from server and update the UI ─────────────────────
function _pollFetchAndApplyResults(optsEl, pollId) {
  const base = (typeof window.__PACELINE_API__ !== 'undefined' ? window.__PACELINE_API__ : 'https://paceline-rye-production.up.railway.app');
  return fetch(base + '/api/poll-results?pollId=' + encodeURIComponent(pollId))
    .then(r => r.ok ? r.json() : null)
    .then(data => {
      if (!data || !data.byChoice) return;
      const opts = optsEl.querySelectorAll('.comm-poll-opt');
      opts.forEach(opt => {
        const label = opt.dataset.label || opt.querySelector('.comm-poll-label')?.textContent?.trim() || '';
        const match = data.byChoice.find(c => c.choice === label);
        const pct   = match ? match.pct : 0;
        const fill  = opt.querySelector('.comm-poll-fill');
        const pctEl = opt.querySelector('.comm-poll-pct');
        if (fill)  { fill.style.transition = 'width .4s ease'; fill.style.width = pct + '%'; }
        if (pctEl) pctEl.textContent = pct + '%';
      });
      const foot = document.getElementById('apCommPollFoot');
      if (foot && optsEl.classList.contains('voted')) {
        foot.style.display = '';
        foot.textContent = 'Thanks for voting!';
      }
    })
    .catch(() => {});
}

// Restore voted state on page load if user already voted today

// Show real poll % whenever the user has voted (any day, not just today)
// Runs after a short delay so the portal's own animation finishes first.
// Show real poll % whenever the user has voted (any day, not just today).
// v3: also fires after a fresh vote click so the flash of portal animation
// is overwritten quickly with real server data.
(function _pollLoadServerResults() {
  const optsEl = document.getElementById('apCommPollOpts');
  if (!optsEl) return;
  const pollId  = optsEl.dataset.pollId || 'default';
  const votedKey = 'pl_voted_' + pollId;
  const base = (typeof window.__PACELINE_API__ !== 'undefined' ? window.__PACELINE_API__ : 'https://paceline-rye-production.up.railway.app');

  function _applyRealPct() {
    fetch(base + '/api/poll-results?pollId=' + encodeURIComponent(pollId))
      .then(r => r.ok ? r.json() : null)
      .then(data => {
        if (!data || !data.byChoice || !data.total) return;
        const opts = optsEl.querySelectorAll('.comm-poll-opt');
        opts.forEach(opt => {
          const label = opt.dataset.label || opt.querySelector('.comm-poll-label')?.textContent?.trim() || '';
          const match = data.byChoice.find(c => c.choice === label);
          const pct   = match ? match.pct : 0;
          const fill  = opt.querySelector('.comm-poll-fill');
          const pctEl = opt.querySelector('.comm-poll-pct');
          if (fill)  fill.style.width = pct + '%';
          if (pctEl) pctEl.textContent = pct + '%';
        });
        const foot = document.getElementById('apCommPollFoot');
        if (foot && data.total > 0) foot.textContent = data.total + ' vote' + (data.total === 1 ? '' : 's');
      })
      .catch(() => {});
  }

  // ── On page load: if already voted, overwrite portal animation with real % ──
  if (localStorage.getItem(votedKey)) {
    // 900ms delay lets the portal's own count-up animation finish first
    setTimeout(_applyRealPct, 900);
  }

  // ── On fresh vote: re-fetch real % after vote POST completes ──────────────
  // Intercepts poll option clicks so we can fire a delayed fetch after voting,
  // overwriting the portal's immediate fake-random display with real data.
  optsEl.addEventListener('click', function(e) {
    const opt = e.target.closest('.comm-poll-opt, [data-choice], [onclick*="CommPoll"]');
    if (!opt) return;
    // Wait 1.5s: vote POST roundtrip + server write + portal animation settle
    setTimeout(_applyRealPct, 1500);
  });
})();
(function _pollRestoreState() {
  const optsEl = document.getElementById('apCommPollOpts');
  if (!optsEl) return;
  const pollId     = optsEl.dataset.pollId || 'default';
  const votedChoice = _pollGetTodayVote(pollId);
  if (!votedChoice) return;

  const opts = optsEl.querySelectorAll('.comm-poll-opt');
  let votedOpt = null;

  opts.forEach(o => {
    const label = o.dataset.label || o.querySelector('.comm-poll-label')?.textContent?.trim();
    if (label === votedChoice) {
      votedOpt = o;
      o.classList.add('on');
      const checkEl = o.querySelector('.comm-poll-check');
      if (checkEl) checkEl.textContent = '✓';
    }
  });

  if (votedOpt) _pollRevealResults(opts, votedOpt, true);
})();

// ── BRAND / PRODUCT PROPOSAL ──────��──────────────────────
const AP_CATALOG_URL  = 'https://paceline-rye-production.up.railway.app/api/catalog-search';
const AP_PROPOSAL_URL = 'https://paceline-rye-production.up.railway.app/api/proposal';

let _propSearchTimer;
function apPropSearch(q) { /* __AP_PROP_NAV_V3__ */
  const resultsEl = document.getElementById('apPropResults');
  if (!resultsEl) return;
  clearTimeout(_propSearchTimer);
  if (!q || q.length < 2) { resultsEl.style.display = 'none'; return; }

  _propSearchTimer = setTimeout(async () => {
    try {
      const r = await fetch(AP_CATALOG_URL + '?q=' + encodeURIComponent(q));
      const { vendors = [], products = [] } = await r.json();

      let html = '';

      if (vendors.length) {
        html += '<div class="prop-result-section-hd">Brands we carry</div>';
        vendors.forEach(function(v) {
          const href = '/search?type=product&q=' + encodeURIComponent(v);
          html += '<div class="prop-result" style="cursor:pointer"' +
            ' data-href="' + href.replace(/"/g, '%22') + '"' +
            ' onclick="location.href=this.dataset.href">' +
            '<div class="prop-result-icon"><span style="font-size:20px;">\uD83C\uDFF7\uFE0F</span></div>' +
            '<div class="prop-result-text">' +
              '<div class="prop-result-name">' + v + '</div>' +
              '<div class="prop-result-meta">Already in catalog &mdash; tap to shop</div>' +
            '</div>' +
            '<span class="prop-result-badge prop-result-badge--have">Shop brand &rarr;</span>' +
          '</div>';
        });
      }

      if (products.length) {
        html += '<div class="prop-result-section-hd">Products we carry</div>';
        products.forEach(function(p) {
          const img = p.image
            ? '<img src="' + p.image + '" alt="">' 
            : '<span style="font-size:18px;">\uD83D\uDECD\uFE0F</span>';
          const href = '/products/' + p.handle;
          html += '<div class="prop-result" style="cursor:pointer"' +
            ' data-href="' + href + '"' +
            ' onclick="location.href=this.dataset.href">' +
            '<div class="prop-result-icon">' + img + '</div>' +
            '<div class="prop-result-text">' +
              '<div class="prop-result-name">' + p.title + '</div>' +
              '<div class="prop-result-meta">' + p.vendor + ' &middot; ' + p.price + '</div>' +
            '</div>' +
            '<span class="prop-result-badge prop-result-badge--have">Shop &rarr;</span>' +
          '</div>';
        });
      }

      if (!html) {
        // Not in catalog — allow proposal. Store value in data-val to avoid
        // embedding user input inside an onclick string attribute.
        const safeQ = q.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
        html = '<div class="prop-result"' +
          ' data-val="' + safeQ + '"' +
          ' onclick="apPropFill(this.dataset.val)">' +
          '<div class="prop-result-icon"><span style="font-size:20px;">\u2728</span></div>' +
          '<div class="prop-result-text">' +
            '<div class="prop-result-name">' + safeQ + '</div>' +
            '<div class="prop-result-meta">Not in our catalog yet &mdash; propose it!</div>' +
          '</div>' +
          '<span class="prop-result-badge prop-result-badge--new">New</span>' +
        '</div>';
      }

      resultsEl.innerHTML = html;
      resultsEl.style.display = 'block';
    } catch(e) {
      console.warn('[paceline:prop-search] failed:', e);
    }
  }, 280);
}
function apPropFill(value) {
  const input = document.getElementById('apPropBrand');
  if (input) { input.value = value; input.focus(); }
  const resultsEl = document.getElementById('apPropResults');
  if (resultsEl) resultsEl.style.display = 'none';
}

// Hide results when clicking outside
document.addEventListener('click', e => {
  if (!e.target.closest('.prop-search-wrap')) {
    const r = document.getElementById('apPropResults');
    if (r) r.style.display = 'none';
  }
});

async function apSubmitProposal() {
  const brand  = document.getElementById('apPropBrand')?.value?.trim();
  const reason = document.getElementById('apPropReason')?.value?.trim();
  if (!brand) { document.getElementById('apPropBrand')?.focus(); return; }

  try {
    await fetch(AP_PROPOSAL_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        brand,
        reason,
        customerId: _apCustomerId(),
        submittedAt: new Date().toISOString(),
      }),
    });
  } catch(e) {
    console.warn('[paceline:proposal] save failed:', e);
  }
  _apTrack('portal_proposal_submitted', { brand });

  const form   = document.getElementById('apPropForm');
  const thanks = document.getElementById('apPropThanks');
  if (form)   form.style.display   = 'none';
  if (thanks) thanks.style.display = 'block';
}

// ── KIT AUDIENCE FILTER ───────────────────────────────────
// Hides kit cards whose identity tags don't match the user's saved sizing audience.
// Products tagged identity:unisex or untagged always show.
// Runs once on load; if no audience preference saved, nothing is hidden.
function apFilterKitByAudience() {
  const prefs = window.__AP_PREFS__?.prefs;
  const savedAud = prefs?.sizing?.audience ?? [];
  if (!savedAud.length) return; // no preference set → show everything

  const userAud = savedAud.map(a => String(a).toLowerCase()); // e.g. ['mens']

  document.querySelectorAll('.kit-pcard[data-audience]').forEach(card => {
    const cardAud = (card.dataset.audience || 'all').toLowerCase();
    if (cardAud === 'all') return; // unisex / untagged → always visible
    // Hide if none of the user's audiences appear in the card's audience string
    if (!userAud.some(a => cardAud.includes(a))) {
      card.hidden = true;
    }
  });
}
apFilterKitByAudience();

// ── FEATURED BRAND SHEET ──────────────────────────────────
function apOpenBrandSheet() {
  const sheet = document.getElementById('apBrandSheet');
  if (!sheet) return;
  sheet.classList.add('open');
  sheet.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
}

function apCloseBrandSheet() {
  const sheet = document.getElementById('apBrandSheet');
  if (!sheet) return;
  sheet.classList.remove('open');
  sheet.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
}

// ── GENERIC RAIL SHUFFLE ─────────────────────────────────
// Works for On the Rise (.rise-card) and Seasonal (.sp-card) rails.
// Initialised on page load — hides overflow cards immediately.
// Each Shuffle press reveals a different set; cycles when pool exhausted.

const RISE_PAGE_SIZE = 6;
const SP_PAGE_SIZE   = 4;
const _railShownMap  = {}; // railId → Set of currently-visible indices

function _apInitRail(railId, selector, pageSize, hiddenClass) {
  const rail = document.getElementById(railId);
  if (!rail) return;
  const all = [...rail.querySelectorAll(selector)];
  if (!all.length) return;
  const shown = new Set(all.map((_, i) => i).slice(0, pageSize));
  _railShownMap[railId] = shown;
  all.forEach((c, i) => c.classList.toggle(hiddenClass, !shown.has(i)));
}

function _apShuffleRail(railId, selector, pageSize, hiddenClass) {
  const rail = document.getElementById(railId);
  if (!rail) return;
  const all = [...rail.querySelectorAll(selector)];
  if (!all.length) return;

  // Fewer cards than page size — just randomly reorder what's there
  if (all.length <= pageSize) {
    const frag = document.createDocumentFragment();
    all.sort(() => Math.random() - 0.5).forEach(c => frag.appendChild(c));
    rail.appendChild(frag);
    rail.scrollTo({ left: 0, behavior: 'smooth' });
    return;
  }

  // Ensure initialised
  if (!_railShownMap[railId]) _apInitRail(railId, selector, pageSize, hiddenClass);

  const shown  = _railShownMap[railId];
  let   hidden = all.map((_, i) => i).filter(i => !shown.has(i));

  // All cards already seen — reset cycle using full pool minus current set
  if (hidden.length === 0) hidden = all.map((_, i) => i).filter(i => !shown.has(i));
  // If still empty (only exactly pageSize cards total), use everyone
  if (hidden.length === 0) hidden = all.map((_, i) => i);

  const next = hidden.sort(() => Math.random() - 0.5).slice(0, Math.min(pageSize, hidden.length));
  _railShownMap[railId] = new Set(next);
  all.forEach((c, i) => c.classList.toggle(hiddenClass, !_railShownMap[railId].has(i)));
  rail.scrollTo({ left: 0, behavior: 'smooth' });
}

function apRiseInit() {
  _apInitRail('apRiseRail', '.rise-card', RISE_PAGE_SIZE, 'rise-card--hidden');
}
function apShuffleRise() {
  _apShuffleRail('apRiseRail', '.rise-card', RISE_PAGE_SIZE, 'rise-card--hidden');
}
function apShuffleSp(railId) {
  _apShuffleRail(railId, '.sp-card', SP_PAGE_SIZE, 'sp-card--hidden');
}

// Boot all rails on load
apRiseInit();
['apEdRail','apNyRail','apMhRail','apSdRail'].forEach(id =>
  _apInitRail(id, '.sp-card', SP_PAGE_SIZE, 'sp-card--hidden')
);

// ── VOTE TOAST HELPER ────────────────────────────────────
function apShowVoteToast(msg) {
  let toast = document.getElementById('apVoteToast');
  if (!toast) {
    toast = document.createElement('div');
    toast.id = 'apVoteToast';
    toast.className = 'ap-vote-toast';
    document.body.appendChild(toast);
  }
  toast.textContent = msg;
  toast.classList.add('show');
  clearTimeout(toast._t);
  toast._t = setTimeout(() => toast.classList.remove('show'), 2200);
}

// ── ANALYTICS HELPER ─────────────────────────────────────
// Fires a Braze custom event — skipped silently for Paceline employees.
function _apTrack(eventName, props = {}) {
  if ((window.__AP_PREFS__ || {}).isEmployee) return;
  try {
    if (window.braze && typeof window.braze.logCustomEvent === 'function') {
      window.braze.logCustomEvent(eventName, props);
    }
  } catch(e) { /* analytics must never break the UI */ }
}

// ── PRODUCT VOTE (Love it / Not for me) ─────────────────

// Build a vote entry object: pid + user's active workout groups + title for readability
function _apVoteEntry(card) {
  const pid   = card?.dataset?.pid ?? 'unknown';
  const title = card?.dataset?.pidTitle ?? card?.querySelector('.cp-name, .fp-name, .wg-title, .rise-brand')?.textContent?.trim() ?? '';
  const prefs = apGetPrefs();
  const workouts = Object.keys(prefs.workouts || {}).filter(k => prefs.workouts[k]);
  return { pid, title, workouts, date: new Date().toISOString().slice(0, 10) };
}

function apVoteLove(btn) {
  const strip = btn.closest('.cp-vote-strip, .vote-strip');
  const card  = btn.closest('.cp-card, [data-pid], .pcard, .fp-card');
  if (strip) strip.querySelectorAll('.cp-vote, .vote-btn').forEach(b => b.classList.remove('voted-love', 'voted-no'));
  btn.classList.add('voted-love');
  apShowVoteToast('❤️ Noted — more like this coming your way.');
  const entry = _apVoteEntry(card);
  _apTrack('portal_vote_love', { product_id: entry.pid, product_name: entry.title });
  apSavePrefs({ votes: { love: [entry] } });
}

function apVoteNo(btn) {
  const card = btn.closest('.cp-card, .wg-card');
  if (!card) return;

  // Save original HTML for undo
  const originalHTML = card.outerHTML;
  const parent = card.parentNode;

  // Animate out
  card.style.transition = 'opacity 0.25s, transform 0.25s';
  card.style.opacity = '0';
  card.style.transform = 'scale(0.95)';

  setTimeout(() => {
    // Replace card with feedback placeholder
    const placeholder = document.createElement('div');
    placeholder.className = card.className + ' cp-card--feedback';
    placeholder.style.cssText = 'display:flex;flex-direction:column;align-items:center;justify-content:center;gap:12px;padding:24px 16px;text-align:center;min-height:200px;background:rgba(71,194,235,.04);border:1px dashed rgba(71,194,235,.15);border-radius:12px;';
    placeholder.innerHTML = `
      <div style="font-size:22px;">👋</div>
      <div style="font-size:13px;font-weight:600;color:var(--ap-white,#fff);line-height:1.4;">Got it — we'll improve your recommendations.</div>
      <div style="font-size:11px;color:var(--ap-dim,#5A8EA3);line-height:1.5;">Thanks for the feedback.</div>
      <div style="display:flex;gap:8px;margin-top:4px;">
        <button onclick="apVoteNoUndo(this)" style="font-size:11px;padding:5px 12px;border:1px solid rgba(71,194,235,.3);background:transparent;color:var(--ap-sky,#47C2EB);border-radius:6px;cursor:pointer;font-family:inherit;">↩ Undo</button>
        <button onclick="apVoteNoDismiss(this)" style="font-size:11px;padding:5px 12px;border:1px solid rgba(71,194,235,.15);background:transparent;color:var(--ap-dim,#5A8EA3);border-radius:6px;cursor:pointer;font-family:inherit;">Dismiss</button>
      </div>`;
    placeholder._originalHTML = originalHTML;
    parent.replaceChild(placeholder, card);
    // Animate in
    placeholder.style.opacity = '0';
    placeholder.style.transition = 'opacity 0.2s';
    requestAnimationFrame(() => { placeholder.style.opacity = '1'; });
  }, 250);

  // Save to preferences with group context
  const entry = _apVoteEntry(card);
  _apTrack('portal_vote_no', { product_id: entry.pid, product_name: entry.title });
  apSavePrefs({ votes: { no: [entry] } });
}

function apVoteNoUndo(btn) {
  const placeholder = btn.closest('.cp-card--feedback');
  if (!placeholder || !placeholder._originalHTML) return;
  const temp = document.createElement('div');
  temp.innerHTML = placeholder._originalHTML;
  const restored = temp.firstElementChild;
  restored.style.opacity = '0';
  restored.style.transition = 'opacity 0.2s';
  placeholder.parentNode.replaceChild(restored, placeholder);
  requestAnimationFrame(() => { restored.style.opacity = '1'; });
}

function apVoteNoDismiss(btn) {
  const placeholder = btn.closest('.cp-card--feedback');
  if (!placeholder) return;
  placeholder.style.transition = 'opacity 0.2s, transform 0.2s';
  placeholder.style.opacity = '0';
  placeholder.style.transform = 'scale(0.9)';
  setTimeout(() => placeholder.remove(), 200);
}

document.addEventListener('keydown', e => {
  if (e.key === 'Escape') apCloseSearch();
});

// ── Admin portal preview mode ─────────────────────────────────────────────────
// When opened via the admin dashboard "Open in Portal" button, the URL contains
// ?preview_cid=XXX&preview_token=abc.  We fetch that customer's prefs from the
// Railway API and re-apply them so you see the portal exactly as they would.
// Params are persisted in sessionStorage so navigating within Shopify (which
// can strip query params) still preserves the preview session for the tab lifetime.
(function _apInitPreviewMode() {
  const params  = new URLSearchParams(location.search);
  let cid       = params.get('preview_cid');
  let token     = params.get('preview_token');

  // Persist to sessionStorage so in-store navigation preserves preview
  if (cid && token) {
    try {
      sessionStorage.setItem('ap_preview_cid',   cid);
      sessionStorage.setItem('ap_preview_token', token);
    } catch {}
  } else {
    // Fall back to sessionStorage if URL params were stripped by Shopify redirect
    try {
      cid   = cid   || sessionStorage.getItem('ap_preview_cid');
      token = token || sessionStorage.getItem('ap_preview_token');
    } catch {}
  }

  if (!cid || !token) return;

  const base = (typeof window.__PACELINE_API__ !== 'undefined')
    ? window.__PACELINE_API__
    : 'https://paceline-rye-production.up.railway.app';

  // Show banner immediately so the page feels intentional
  const banner = document.createElement('div');
  banner.id = 'apPreviewBanner';
  banner.style.cssText = [
    'position:fixed;top:0;left:0;right:0;z-index:99999',
    'background:#EBB447;color:#000',
    'font-size:12px;font-weight:700;text-align:center',
    'padding:7px 16px;letter-spacing:.04em',
    'box-shadow:0 2px 8px rgba(0,0,0,.4)',
  ].join(';');
  banner.textContent = '👁 Admin Preview — loading customer data…';
  document.body.prepend(banner);

  // Add top padding to the portal root so banner doesn't overlap content
  const root = document.getElementById('ap-root') || document.querySelector('.ap-root');
  if (root) root.style.paddingTop = '32px';

  fetch(`${base}/api/portal-preview-prefs?customerId=${encodeURIComponent(cid)}&token=${encodeURIComponent(token)}`)
    .then(r => r.json())
    .then(({ prefs, customer, stats, error }) => {
      if (error) { banner.textContent = `👁 Preview error: ${error}`; banner.style.background = '#f87171'; return; }

      // Inject prefs as if Shopify rendered them for this customer
      if (!window.__AP_PREFS__) window.__AP_PREFS__ = {};
      window.__AP_PREFS__.prefs      = prefs || {};
      window.__AP_PREFS__.isLoggedIn = true;
      window.__AP_PREFS__.customerId = String(cid);

      // Seed localStorage so filter/size logic reads it (but mark as preview so saves are blocked)
      try {
        localStorage.setItem('ap_prefs', JSON.stringify(prefs || {}));
        sessionStorage.setItem('ap_preview_active', '1');
      } catch {}

      // Re-run prefs restore with the customer's actual data
      const p = prefs || {};
      if (typeof apApplyOptinStrips === 'function') apApplyOptinStrips(p.seasonal?.optins || {}, p.seasonal?.dismissed || {});
      if (typeof apWgInit === 'function') apWgInit();
      if (typeof apInitSizing === 'function') apInitSizing();

      // ── Inject real stats over the Liquid demo values ─────────────────────
      const name = [customer?.first_name, customer?.last_name].filter(Boolean).join(' ');
      // Greeting
      const greetH2 = document.querySelector('.g-card h2');
      if (greetH2 && name) {
        greetH2.innerHTML = greetH2.innerHTML
          .replace(/,\s*there\./, `, ${name}.`)
          .replace(/^there\./, `${name}.`);
      }
      // Stats
      if (stats) {
        // Streak
        const streakEl = document.querySelector('.stat-val:not([data-ap-cents]):not([data-ap-number])');
        if (streakEl && stats.streak != null) streakEl.textContent = stats.streak;
        // Points
        const pointsEl = document.querySelector('.stat-val[data-ap-number]');
        if (pointsEl && stats.points != null) {
          pointsEl.textContent = stats.points.toLocaleString();
          pointsEl.setAttribute('data-ap-number', stats.points);
        }
      }

      // Replace the Liquid demo-mode banner with a more accurate admin preview banner
      const demoBanner = document.getElementById('apDemoBanner');
      if (demoBanner) demoBanner.remove();

      banner.innerHTML = `👁&nbsp;<strong>Admin Preview</strong>&nbsp;·&nbsp;${name || 'Customer'}&nbsp;<span style="font-weight:400;opacity:.75">(${customer?.email || 'ID ' + cid})</span>&nbsp;·&nbsp;<span style="font-weight:400;opacity:.75">real prefs + stats loaded — writes disabled</span>`;
    })
    .catch(err => {
      banner.textContent = `👁 Preview failed: ${err.message}`;
      banner.style.background = '#f87171';
    });
})();

// (WG section already booted above via apWgInit())



// Dismiss "Shopping for someone?" card after Save; re-show only for new occasions.
(function _apSeasonalOptinDismiss() {
  const soSec = document.querySelector('.seasonal-optin');
  if (!soSec) return;

  function _soGetChips() {
    return [...soSec.querySelectorAll('.occ-chip, .so-chip, [data-occasion]')];
  }

  // On page load: hide section if all shown occasions are already opted-in
  function _soCheckAlreadySaved() {
    const chips = _soGetChips();
    if (!chips.length) return;
    const prefs      = (typeof apGetPrefs === 'function') ? apGetPrefs() : {};
    const savedOptins = new Set(
      (prefs?.seasonal?.optins ?? []).map(o => String(o).toLowerCase())
    );
    const allKeys = chips.map(c =>
      (c.dataset.key || c.dataset.occasion || c.textContent.trim()).toLowerCase()
    );
    if (allKeys.length && allKeys.every(k => savedOptins.has(k))) {
      soSec.style.display = 'none';
    } else {
      // Pre-check chips already saved
      chips.forEach(chip => {
        const key = (chip.dataset.key || chip.dataset.occasion || chip.textContent.trim()).toLowerCase();
        if (savedOptins.has(key)) chip.classList.add('on');
      });
    }
  }
  _soCheckAlreadySaved();

  // Dismiss helper: fade out then hide
  function _soDismiss() {
    soSec.style.transition = 'opacity 0.25s';
    soSec.style.opacity    = '0';
    setTimeout(() => { soSec.style.display = 'none'; }, 260);
  }

  // Patch existing apSaveSeasonalOptins if present, otherwise inject one
  const origSave = window.apSaveSeasonalOptins;
  window.apSaveSeasonalOptins = async function(btn) {
    if (origSave) await origSave.call(this, btn);
    _soDismiss();
  };

  // Also handle a plain save button inside the section (belt-and-suspenders)
  const saveBtn = soSec.querySelector('button[onclick*="Seasonal"], button[onclick*="seasonal"], button[onclick*="Occasion"], .so-save-btn, [class*="pref-save"]');
  if (saveBtn && !saveBtn._soDismissWired) {
    saveBtn._soDismissWired = true;
    saveBtn.addEventListener('click', () => setTimeout(_soDismiss, 400));
  }
})();


// Cross-section dedup v2 — section-agnostic; rise section excluded.
(function _apDeduplicateSections() {
  function _findCard(link) {
    var el = link;
    while (el.parentElement && el.parentElement !== document.body) {
      var sibs = [].slice.call(el.parentElement.children).filter(function(c) {
        return c !== el && c.querySelector('a[href*="/products/"]');
      });
      if (sibs.length > 0) return el;
      el = el.parentElement;
    }
    return link;
  }

  function _isRise(el) {
    var node = el;
    while (node && node !== document.body) {
      var cls = (node.className || '').toLowerCase();
      var id  = (node.id || '').toLowerCase();
      if (/rise/.test(cls) || /rise/.test(id)) return true;
      node = node.parentElement;
    }
    return false;
  }

  function _dedup() {
    var seen = new Set();
    var hidden = 0;
    document.querySelectorAll('a[href*="/products/"]').forEach(function(link) {
      var m = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
      if (!m || !m[1] || m[1] === 'all') return;
      var handle = m[1];
      var card = _findCard(link);
      if (_isRise(card)) return; // always keep on-the-rise products visible
      if (seen.has(handle)) {
        card.style.display = 'none';
        hidden++;
      } else {
        seen.add(handle);
      }
    });
    console.log('[paceline] dedup v2: ' + hidden + ' duplicate(s) hidden');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { setTimeout(_dedup, 1000); });
  } else {
    setTimeout(_dedup, 1000);
  }
})();


// Commission cost logger — fetches per-brand commission rates and logs cost to console.
(function _apCommissionPricing() {
  const base = (typeof window.__PACELINE_API__ !== 'undefined' ? window.__PACELINE_API__ : 'https://paceline-rye-production.up.railway.app');
  fetch(base + '/api/commissions')
    .then(function(r) { return r.ok ? r.json() : null; })
    .then(function(data) {
      if (!data || !data.commissions) return;
      const comms = data.commissions;
      document.querySelectorAll('.sp-card, .fp-card, .kit-pcard, .rise-card, .so-card, [data-product-id]').forEach(function(card) {
        const brandEl = card.querySelector('[class*="-brand"], .sr-brand, .sp-brand');
        if (!brandEl) return;
        const brand = brandEl.textContent.trim();
        const pct = comms[brand];
        if (!pct || pct <= 0) return;
        const priceEl = card.querySelector('[class*="-price"]:not([class*="-orig"])');
        if (!priceEl) return;
        const price = parseFloat(priceEl.textContent.replace(/[^0-9.]/g, ''));
        if (!price) return;
        const cost = price * (1 - pct / 100);
        console.log('[paceline] ' + brand + ' — price: $' + price.toFixed(2) + ', commission: ' + pct + '%, cost: $' + cost.toFixed(2));
      });
    })
    .catch(function() {});
})();


// Hide products the current user has personally marked "not for me".
(function _apHidePersonalNoVotes() {
  var prefs = null;
  try {
    prefs = (window.__AP_PREFS__ && window.__AP_PREFS__.prefs)
         || JSON.parse(localStorage.getItem('ap_prefs') || 'null');
  } catch {}
  var noList = ((prefs && prefs.votes && prefs.votes.no) || []).map(function(e) {
    return typeof e === 'object' && e !== null ? String(e.pid) : String(e);
  });
  if (!noList.length) return;
  var noHandles = new Set(noList); // may contain handles OR numeric IDs

  function _hideCards() {
    document.querySelectorAll('a[href*="/products/"]').forEach(function(link) {
      var m = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
      if (!m) return;
      var handle = m[1];
      if (handle === '' || handle === 'all') return;

      // Walk up to find the card (direct child of its section row/grid)
      var card = link;
      while (card.parentElement && card.parentElement !== document.body) {
        var next = card.parentElement;
        // Stop when parent has multiple product-link siblings — that's the grid level
        if (next.children.length > 1 &&
            [].slice.call(next.children).some(function(c) {
              return c !== card && c.querySelector('a[href*=\"/products/\"]');
            })) break;
        // Also check for numeric product ID on ancestors
        if (next.dataset) {
          var pid = next.dataset.productId || next.dataset.product || next.dataset.id;
          if (pid && noHandles.has(String(pid))) { next.style.display = 'none'; return; }
        }
        card = next;
      }
      if (noHandles.has(handle)) card.style.display = 'none';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { setTimeout(_hideCards, 200); });
  } else {
    setTimeout(_hideCards, 200);
  }
})();


// Community aggregate deprioritisation — moves low-score product cards to the
// end of their section (not hidden; community signal ≠ individual preference).
(function _apDeprioritizeLowScore() {
  var base = (typeof window.__PACELINE_API__ !== 'undefined' ? window.__PACELINE_API__ : 'https://paceline-rye-production.up.railway.app');
  fetch(base + '/api/product-vote/low-score')
    .then(function(r) { return r.ok ? r.json() : null; })
    .then(function(data) {
      if (!data) return;
      var lowPids   = new Set(data.products || []);
      var lowBrands = new Set((data.brands || []).map(function(b) { return b.toLowerCase(); }));
      if (!lowPids.size && !lowBrands.size) return;

      var PRIORITY_SECTIONS = [
        '#apKitSec', '.this-weeks-kit',
        '#apFlashSec', '.flash-picks',
        '#apRiseSec', '.on-the-rise-prods',
        '#apWorkoutSec', '.workout-prods',
        '#apSeasonalSec', '.seasonal-prods',
      ];

      var visited = new Set();
      PRIORITY_SECTIONS.forEach(function(sel) {
        var sec = document.querySelector(sel);
        if (!sec || visited.has(sec)) return;
        visited.add(sec);

        var links = sec.querySelectorAll('a[href*="/products/"]');
        links.forEach(function(link) {
          var m = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
          if (!m) return;
          var handle = m[1];

          // Walk up to card (direct child of section)
          var card = link;
          while (card.parentElement && card.parentElement !== sec) {
            card = card.parentElement;
          }

          var isLow = lowPids.has(handle);
          if (!isLow) {
            // Check numeric ID
            var el = link;
            while (el && el !== sec) {
              var pid = el.dataset && (el.dataset.productId || el.dataset.product || el.dataset.id);
              if (pid && lowPids.has(String(pid))) { isLow = true; break; }
              el = el.parentElement;
            }
          }
          if (!isLow && lowBrands.size) {
            // Check vendor element inside card
            var brandEl = card.querySelector('[class*="-brand"], .sr-brand, .sp-brand');
            if (brandEl && lowBrands.has(brandEl.textContent.trim().toLowerCase())) isLow = true;
          }

          if (isLow) {
            card.style.opacity = '0.55';
            card.title = 'Low community score';
            sec.appendChild(card); // move to end
          }
        });
      });
    })
    .catch(function() {});
})();


// Love-based personalisation — boosts products loved by the user's workout group(s).
(function _apLoveBoost() {
  var prefs = null;
  try {
    prefs = (window.__AP_PREFS__ && window.__AP_PREFS__.prefs)
         || JSON.parse(localStorage.getItem('ap_prefs') || 'null');
  } catch {}
  var workouts = (prefs && Array.isArray(prefs.workouts) && prefs.workouts.length)
    ? prefs.workouts : [];

  var base = (typeof window.__PACELINE_API__ !== 'undefined'
    ? window.__PACELINE_API__ : 'https://paceline-rye-production.up.railway.app');
  var url = base + '/api/product-vote/recommendations'
    + (workouts.length ? '?workouts=' + encodeURIComponent(workouts.join(',')) : '');

  fetch(url)
    .then(function(r) { return r.ok ? r.json() : null; })
    .then(function(data) {
      if (!data || !data.recommendations || !data.recommendations.length) return;

      // Build handle/pid → rank map (0 = most loved)
      var loved = new Map();
      data.recommendations.forEach(function(rec, i) { loved.set(String(rec.pid), i); });

      var groupLabel = workouts.length ? workouts[0] : 'members';

      // Find card given a product link (sibling-based, no class names)
      function findCard(link) {
        var el = link;
        while (el.parentElement && el.parentElement !== document.body) {
          var sibs = [].slice.call(el.parentElement.children).filter(function(c) {
            return c !== el && c.querySelector('a[href*="/products/"]');
          });
          if (sibs.length > 0) return el;
          el = el.parentElement;
        }
        return link;
      }

      // Collect all grids (parents of cards) so we can reorder within each
      var grids = new Map(); // grid el → array of { card, handle, rank }
      document.querySelectorAll('a[href*="/products/"]').forEach(function(link) {
        var m = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
        if (!m || !m[1] || m[1] === 'all') return;
        var handle = m[1];
        var card = findCard(link);
        var grid = card.parentElement;
        if (!grid || grid === document.body) return;
        if (!grids.has(grid)) grids.set(grid, []);
        grids.get(grid).push({ card: card, handle: handle });
      });

      grids.forEach(function(items, grid) {
        // Guard: skip section containers — they have children each holding many product links.
        // True product grids have 1–2 links per child (the card itself).
        var childLinkCounts = [].slice.call(grid.children).map(function(c) {
          return c.querySelectorAll('a[href*="/products/"]').length;
        });
        var avg = childLinkCounts.length
          ? childLinkCounts.reduce(function(a, b) { return a + b; }, 0) / childLinkCounts.length
          : 0;
        if (avg > 3) return;

        var toBoost = [];
        items.forEach(function(item) {
          var rank = loved.has(item.handle) ? loved.get(item.handle) : null;
          // Also check numeric product ID data attrs
          if (rank === null) {
            var el = item.card;
            while (el && el !== grid) {
              var pid = el.dataset && (el.dataset.productId || el.dataset.product || el.dataset.id);
              if (pid && loved.has(String(pid))) { rank = loved.get(String(pid)); break; }
              el = el.parentElement;
            }
          }
          if (rank !== null) toBoost.push({ card: item.card, rank: rank });
        });

        if (!toBoost.length) return;
        toBoost.sort(function(a, b) { return a.rank - b.rank; });
        toBoost.forEach(function(item) {
          grid.insertBefore(item.card, grid.firstChild);
        });
      });

      console.log('[paceline] love-boost: boosted ' + data.recommendations.length
        + ' product(s) for group(s): ' + (workouts.join(', ') || 'all members'));
    })
    .catch(function() {});
})();


// Strip emojis from non-seasonal section headers and labels.
(function _apStripEmojis() {
  // Unicode emoji ranges (covers all major emoji blocks)
  var EMOJI_RE = /[\u{1F300}-\u{1FAFF}\u{2600}-\u{27BF}\u{FE00}-\u{FE0F}\u{1F000}-\u{1F02F}\u{1F0A0}-\u{1F0FF}\u{1F100}-\u{1F1FF}\u{1F200}-\u{1F2FF}]/gu;

  // Keywords that identify seasonal sections — skip emoji stripping inside these
  var SEASONAL_KEYS = ['seasonal', 'mothers-day', "mother's-day", 'earth-day', 'fathers-day',
    "father's-day", 'valentines', 'mental-health', 'holiday', 'pride', 'halloween',
    'breast-cancer', 'sleep-day', 'new-year', 'spring', 'summer', 'fall', 'winter'];

  function isSeasonal(el) {
    var ancestor = el;
    while (ancestor && ancestor !== document.body) {
      var cls = (ancestor.className || '').toLowerCase();
      var id  = (ancestor.id || '').toLowerCase();
      var dat = JSON.stringify(ancestor.dataset || '').toLowerCase();
      if (SEASONAL_KEYS.some(function(k) { return cls.includes(k) || id.includes(k) || dat.includes(k); })) return true;
      ancestor = ancestor.parentElement;
    }
    return false;
  }

  function stripNode(node) {
    if (node.nodeType === 3) { // TEXT_NODE
      var orig = node.textContent;
      var stripped = orig.replace(EMOJI_RE, '').replace(/^\s+/, '');
      if (stripped !== orig) node.textContent = stripped;
    } else if (node.nodeType === 1 && !isSeasonal(node)) {
      [].slice.call(node.childNodes).forEach(stripNode);
    }
  }

  // Target: section headers, eyebrow labels, section titles, inspiration labels
  // Leave vote buttons (❤ / ✕) and badges alone
  var TARGETS = [
    'h1', 'h2', 'h3', 'h4',
    '[class*="sec-eye"]', '[class*="eyebrow"]', '[class*="sec-title"]',
    '[class*="section-title"]', '[class*="section-label"]',
    '[class*="flash-eye"]', '[class*="-sub"]', '[class*="inspiration"]',
    '[class*="sec-head"]', '[class*="section-head"]',
  ];

  function run() {
    TARGETS.forEach(function(sel) {
      document.querySelectorAll(sel).forEach(function(el) {
        if (!isSeasonal(el)) stripNode(el);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();


// Targeted emoji strip — vote labels, poll options, flash/workout headings.
// Skips interactive elements (chips, buttons with data-* values) so chip
// selection logic is unaffected.
(function _apStripSpecific() {
  var EMOJI_RE = /[\u{1F300}-\u{1FAFF}\u{2600}-\u{27BF}\u{FE00}-\u{FE0F}\u{1F000}-\u{1F02F}]/gu;

  function hasInteractiveAncestor(el) {
    var node = el;
    while (node && node !== document.body) {
      var tag = (node.tagName || '').toUpperCase();
      if (tag === 'BUTTON' || tag === 'A') return true;
      if (node.getAttribute && (node.getAttribute('role') === 'button' || node.getAttribute('onclick'))) return true;
      if (node.dataset && (node.dataset.key || node.dataset.occasion || node.dataset.workout || node.dataset.value)) return true;
      var cls = node.className || '';
      if (/chip|occ-chip|so-chip|pref-chip|workout-chip/i.test(cls)) return true;
      node = node.parentElement;
    }
    return false;
  }

  function stripEl(el) {
    if (!el || hasInteractiveAncestor(el)) return;
    [].slice.call(el.childNodes).forEach(function(node) {
      if (node.nodeType === 3) {
        var s = node.textContent.replace(EMOJI_RE, '').replace(/^\s+/, '');
        if (s !== node.textContent) node.textContent = s;
      }
    });
  }

  function run() {
    // Vote button text labels (not the icon span — just the label)
    document.querySelectorAll('.cp-vote-lbl').forEach(stripEl);
    // Community poll option labels
    document.querySelectorAll('.comm-poll-label, .comm-poll-opt-lbl').forEach(stripEl);
    // Flash Picks eyebrow/heading
    document.querySelectorAll('.flash-eye, .flash-hd, .flash-title').forEach(stripEl);
    // Workout / pref section headings only (not chips inside)
    document.querySelectorAll('.workout-hd, .pref-hd').forEach(stripEl);
    // Staff Pick badge — hide entirely
    document.querySelectorAll('.sp-badge, [class*="staff-pick"], [class*="staffpick"]').forEach(function(el) {
      el.style.display = 'none';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { setTimeout(run, 400); });
  } else {
    setTimeout(run, 400);
  }
})();


// Hide seasonal picks sections until user has opted in via "Shopping for someone?" card.
(function _apGateSeasonalPicks() {
  var prefs = null;
  try {
    prefs = (window.__AP_PREFS__ && window.__AP_PREFS__.prefs)
         || JSON.parse(localStorage.getItem('ap_prefs') || 'null');
  } catch {}

  var optins = (prefs && prefs.seasonal && Array.isArray(prefs.seasonal.optins))
    ? prefs.seasonal.optins.map(function(o) { return String(o).toLowerCase().replace(/[^a-z]/g, ''); })
    : [];

  var SEASONAL_WORDS = ['mother','father','valentine','holiday','pride','earth','mental','breast','cancer'];

  function keyOf(text) {
    var t = (text || '').toLowerCase().replace(/[^a-z ]/g, '');
    for (var i = 0; i < SEASONAL_WORDS.length; i++) {
      if (t.indexOf(SEASONAL_WORDS[i]) !== -1) return SEASONAL_WORDS[i];
    }
    return null;
  }

  function isOptedIn(key) {
    return optins.some(function(o) { return o.indexOf(key) !== -1 || key.indexOf(o) !== -1; });
  }

  function run() {
    var soSec = document.querySelector('.seasonal-optin, [class*="seasonal-optin"]');
    // If the optin card is absent or already hidden, user has dismissed — do nothing
    if (!soSec || window.getComputedStyle(soSec).display === 'none') return;

    document.querySelectorAll('[class*="sec-eye"], [class*="eyebrow"], .sec-eye').forEach(function(eye) {
      var key = keyOf(eye.textContent);
      if (!key) return;
      if (isOptedIn(key)) return; // user opted in — leave visible

      // Walk up from the eyebrow to find the nearest ancestor that contains product links.
      // That ancestor is the "Picks for her" section — hide it.
      var sec = eye.parentElement;
      while (sec && sec !== document.body) {
        if (sec === soSec) return; // never hide the optin card itself
        if (sec.querySelector('a[href*=\"/products/\"]')) {
          sec.style.display = 'none';
          return;
        }
        sec = sec.parentElement;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { setTimeout(run, 600); });
  } else {
    setTimeout(run, 600);
  }
})();


// Click attribution tracking — fires on every product card/link click.
(function _apTrackClicks() {
  if (document._apClickTrackWired) return;
  document._apClickTrackWired = true;
  var base = (typeof window.__PACELINE_API__ !== 'undefined' ? window.__PACELINE_API__ : 'https://paceline-rye-production.up.railway.app');
  document.addEventListener('click', function(e) {
    var link = e.target.closest('a[href*="/products/"]');
    if (!link) return;
    var m = (link.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    if (!m || !m[1] || m[1] === 'all') return;
    var handle = m[1];
    var card = link;
    while (card.parentElement && card.parentElement !== document.body) {
      if (card.parentElement.children.length > 1 &&
          [].slice.call(card.parentElement.children).some(function(c) {
            return c !== card && c.querySelector('a[href*=\"/products/\"]');
          })) break;
      card = card.parentElement;
    }
    // Brand detection — try in priority order:
    // 1. link itself (kit-pcard: the <a> wraps the whole card including .kit-brand)
    // 2. card after walk-up (works when card is a parent wrapper)
    // 3. data attributes on link or ancestors
    function _getBrand(root) {
      var el = root.querySelector('[class*="-brand"],[class*="-vendor"]')
             || root.querySelector('[class*="brand"],[class*="vendor"]');
      if (!el) return '';
      return (el.getAttribute('data-brand') || el.getAttribute('data-vendor') || el.textContent || '').trim();
    }
    var brand = _getBrand(link) || _getBrand(card);
    // data-brand / data-vendor fallback on link or ancestor
    if (!brand) {
      var anc = link;
      while (anc && anc !== document.body && !brand) {
        brand = (anc.getAttribute && (anc.getAttribute('data-brand') || anc.getAttribute('data-vendor'))) || '';
        anc = anc.parentElement;
      }
    }
    var titleEl = card.querySelector('[class*="-name"],[class*="-title"]');
    var title   = titleEl ? titleEl.textContent.trim() : '';
    var productId = (card.dataset && (card.dataset.productId || card.dataset.id)) || null;
    // Section detection: walk up to find a section container with a recognisable id/class
    var section = 'unknown';
    var node = card;
    while (node && node !== document.body) {
      var cls = (node.className || '').toLowerCase();
      var id  = (node.id || '').toLowerCase();
      if (/flash/.test(cls+id)) { section = 'flash-picks'; break; }
      if (/rise/.test(cls+id))  { section = 'on-the-rise'; break; }
      if (/kit/.test(cls+id))   { section = 'weekly-kit';  break; }
      if (/seasonal|mother|father|holiday|pride/.test(cls+id)) { section = 'seasonal'; break; }
      if (/trending|spotlight|sp-sec/.test(cls+id)) { section = 'trending'; break; }
      if (/inspir|workout-gear/.test(cls+id)) { section = 'inspiration'; break; }
      if (/search/.test(cls+id)) { section = 'search'; break; }
      node = node.parentElement;
    }
    var sid        = localStorage.getItem('ap_vsid') || '';
    var customerId = (window.__AP_PREFS__ && window.__AP_PREFS__.customerId)
                   ? String(window.__AP_PREFS__.customerId) : null;
    var customerEmail = (window.__AP_PREFS__ && window.__AP_PREFS__.email) || null;
    // Store click token for post-purchase attribution (session-scoped, 30-min TTL)
    try {
      var token = { handle: handle, brand: brand, placement: section, ts: Date.now() };
      sessionStorage.setItem('ap_last_click', JSON.stringify(token));
    } catch {}
    // ap-click-v5: POST to /api/attribution — Railway logs click for webhook correlation.
    // The orders/create webhook reads this log to write a paceline/attribution order metafield.
    // No cart attributes used (avoids polluting "Additional details" on the Shopify order).
    fetch(base + '/api/attribution', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        productId:     productId || handle,
        handle:        handle,
        brand:         brand,
        title:         title,
        placement:     section,
        sessionId:     sid,
        customerId:    customerId,
        customerEmail: customerEmail,
      }),
    }).catch(function() {});
  });
})();


// Order status label correction — "In transit." → "In progress." when not yet shipped
(function _apFixOrderStatusLabel() {
  if (document._apOrderStatusFixed) return;
  document._apOrderStatusFixed = true;
  function _fix() {
    // Find leaf elements whose text is just "transit" or "transit." (the italic accent word)
    var candidates = document.querySelectorAll('em,i,b,strong,span,h1,h2,h3,h4');
    candidates.forEach(function(el) {
      if (el.children.length > 0) return;
      var t = el.textContent.trim().toLowerCase();
      if (t !== 'transit.' && t !== 'transit') return;
      // Walk up to find the orders section container
      var sec = el;
      for (var i = 0; i < 6; i++) { if (!sec.parentElement) break; sec = sec.parentElement; }
      var txt = sec.innerText || sec.textContent || '';
      var hasProcessing = /processing/i.test(txt);
      var hasTracking   = /tracking number|track (your|order)|out for delivery/i.test(txt);
      if (hasProcessing && !hasTracking) {
        el.textContent = el.textContent.replace(/transit/gi, function(m) {
          return m[0] === m[0].toUpperCase() ? 'Progress' : 'progress';
        });
      }
    });
  }
  // Run immediately, after DOM ready, and after portal async data loads
  if (document.readyState !== 'loading') _fix();
  document.addEventListener('DOMContentLoaded', _fix);
  [800, 2000, 4000].forEach(function(ms) { setTimeout(_fix, ms); });
})();


// "Find Inspiration For" goal picker — null-safe override (Fix 16 v3)
// Always installs null-safe window.apGoalOpenPicker / apGoalPickerSelect,
// replacing the Liquid's version which has no null checks and crashes when
// #apGoalDisplay or #apGoalEmojiDisplay isn't in the DOM at call time.
// Reads ap-layout-goal from localStorage to mirror the Liquid's _apLayouts.goal.
(function _apGoalPickerFallback() {
  // ── Debug: log pane states 1.2s after load ──────────────────────────────────
  setTimeout(function() {
    for (var i = 0; i < 4; i++) {
      var pane = document.getElementById('goalPane' + i);
      if (!pane) break;
      var cards = pane.querySelectorAll('[data-pid], .cp-card, .wg-card');
      console.log('[paceline] goalPane' + i + ': display=' + pane.style.display + ' cards=' + cards.length);
    }
  }, 1200);

  // ── Read layout preference (mirrors Liquid _apLayouts.goal) ─────────────────
  // Liquid defaults to 'rise' (showcase) unless user explicitly chose 'grid'.
  function _getLayout() {
    try { return localStorage.getItem('ap-layout-goal') === 'grid' ? 'grid' : 'rise'; }
    catch(e) { return 'rise'; }
  }

  // ── Always install null-safe versions (replace Liquid's no-null-check impl) ──
  window.apGoalOpenPicker = function(e) {
    if (e) e.stopPropagation();
    var picker = document.getElementById('apGoalPicker');
    if (!picker) return;
    var isOpen = picker.classList.contains('open');
    document.querySelectorAll('.wg-picker.open').forEach(function(p) { p.classList.remove('open'); });
    if (!isOpen) picker.classList.add('open');
  };

  window.apGoalPickerSelect = function(idx, emoji, label) {
    // Null-safe display updates (Liquid version has no null checks — crash fix)
    var disp    = document.getElementById('apGoalDisplay');
    var emojiEl = document.getElementById('apGoalEmojiDisplay');
    if (disp)    disp.textContent    = label;
    if (emojiEl) emojiEl.textContent = emoji;
    // Active state on picker items (index-based, matches forloop.index0)
    document.querySelectorAll('#apGoalPicker .wg-picker-item').forEach(function(el, i) {
      el.classList.toggle('active', i === idx);
    });
    var picker = document.getElementById('apGoalPicker');
    if (picker) picker.classList.remove('open');
    // Show/hide panes — respect layout mode from localStorage
    var isRise = _getLayout() === 'rise';
    for (var i = 0; i < 4; i++) {
      var pane = document.getElementById('goalPane' + i);
      if (!pane) continue;
      var show = (i === idx);
      if (show) {
        pane.style.display = isRise ? 'flex' : 'grid';
        pane.classList.toggle('layout--rise', isRise);
      } else {
        pane.style.display = 'none';
        pane.classList.remove('layout--rise');
      }
      pane.classList.toggle('goal-pane--active', show);
    }
    console.log('[paceline] goal picker: selected idx=' + idx + ' "' + label + '" isRise=' + isRise);
  };

  // Outside-click close
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.wg-picker-wrap')) {
      document.querySelectorAll('.wg-picker.open').forEach(function(p) { p.classList.remove('open'); });
    }
  });
})();


// Goal pane empty-state placeholder (Fix 17)
(function _apGoalEmptyState() {
  function _run() {
    var picker = document.getElementById('apGoalPicker');
    if (!picker) return;
    var items = picker.querySelectorAll('.wg-picker-item');
    for (var i = 0; i < 10; i++) {
      var pane = document.getElementById('goalPane' + i);
      if (!pane) break;
      // Count actual product cards (not placeholders we already added)
      var cards = pane.querySelectorAll('.cp-card, .sp-card, .wg-card, [data-pid]');
      if (!cards.length) {
        // Add a subtle placeholder if not already present
        if (!pane.querySelector('._ap-goal-empty')) {
          var msg = document.createElement('div');
          msg.className = '_ap-goal-empty';
          msg.style.cssText = 'grid-column:1/-1;padding:32px 16px;text-align:center;color:var(--ap-dim,#5A7080);font-size:13px;';
          msg.textContent = 'Products coming soon to this category.';
          pane.appendChild(msg);
        }
        // Dim the corresponding picker item
        if (items[i]) {
          items[i].style.opacity = '0.45';
          items[i].title = 'No products yet in this category';
        }
      }
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { setTimeout(_run, 800); });
  } else {
    setTimeout(_run, 800);
  }
})();


// Flash Picks showcase layout — default swipe + grid toggle (Fix 18)
(function _apFlashShowcase() {
  var STORAGE_KEY = 'ap-layout-flash';
  var GRID_ID     = 'apFlashPicksGrid';
  var BTN_CLASS   = 'fp-layout-btn';

  function _getLayout() {
    try { return localStorage.getItem(STORAGE_KEY) || 'showcase'; }
    catch(e) { return 'showcase'; }
  }
  function _setLayout(val) {
    try { localStorage.setItem(STORAGE_KEY, val); } catch(e) {}
  }

  function _applyLayout(grid, btn, layout) {
    if (layout === 'showcase') {
      grid.classList.add('layout--showcase');
      if (btn) btn.textContent = 'Grid view';
    } else {
      grid.classList.remove('layout--showcase');
      if (btn) btn.textContent = 'Showcase';
    }
  }

  function _run() {
    var grid = document.getElementById(GRID_ID);
    if (!grid) return;

    // Find or create the toggle button in .flash-head
    var head   = grid.closest('.flash-section, [class*="flash"]')
                   ? grid.closest('.flash-section, [class*="flash"]').querySelector('.flash-head')
                   : null;
    // Fallback: look for .flash-head anywhere above the grid
    if (!head) {
      var parent = grid.parentElement;
      while (parent && !head) {
        head   = parent.querySelector('.flash-head');
        parent = parent.parentElement;
      }
    }

    var btn = head ? head.querySelector('.' + BTN_CLASS) : null;
    if (!btn && head) {
      // Wrap existing head content in .flash-head-text if not already wrapped
      if (!head.querySelector('.flash-head-text')) {
        var wrapper = document.createElement('div');
        wrapper.className = 'flash-head-text';
        while (head.firstChild) wrapper.appendChild(head.firstChild);
        head.appendChild(wrapper);
      }
      btn = document.createElement('button');
      btn.className = BTN_CLASS;
      btn.type = 'button';
      head.appendChild(btn);
    }

    var layout = _getLayout();
    _applyLayout(grid, btn, layout);

    if (btn && !btn._apFlashBound) {
      btn._apFlashBound = true;
      btn.addEventListener('click', function(e) {
        e.stopPropagation();
        var current = grid.classList.contains('layout--showcase') ? 'showcase' : 'grid';
        var next    = current === 'showcase' ? 'grid' : 'showcase';
        _setLayout(next);
        _applyLayout(grid, btn, next);
        console.log('[paceline] flash-picks layout toggled to', next);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { setTimeout(_run, 400); });
  } else {
    setTimeout(_run, 400);
  }
  // Re-run after async portal data may have rendered the grid
  [1200, 2500].forEach(function(ms) { setTimeout(_run, ms); });
})();


(function _apRecoverPreviewMode() {
  if (window.__AP_PREFS__ && window.__AP_PREFS__.customerId) return; // already have real data
  var base = (window.__rpBase || 'https://paceline-rye-production.up.railway.app');

  function tryRecover() {
    // Shopify injects window.Shopify.customer.id when logged in via storefront
    var cid = (window.Shopify && window.Shopify.customer && window.Shopify.customer.id)
            ? String(window.Shopify.customer.id) : null;
    // Also check URL param for manual override (?preview_cid=xxx)
    if (!cid) {
      var m = window.location.search.match(/[?&]preview_cid=([0-9]+)/);
      if (m) cid = m[1];
    }
    if (!cid) return; // genuinely not logged in

    // Mark as logged in immediately so apSavePrefs fires on portal pages that
    // don't render page-app-portal.liquid (kits-portal, flash-sales-portal).
    if (!window.__AP_PREFS__) window.__AP_PREFS__ = {};
    window.__AP_PREFS__.customerId = cid;
    window.__AP_PREFS__.isLoggedIn = true;

    // Fetch existing prefs so portal shows saved state on these pages too
    fetch(base + '/api/portal-prefs?customerId=' + cid)
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (!data.prefs) return; // customer has no metafield yet — that's fine
        if (window.__AP_PREFS__) {
          // Merge into existing object so Liquid-injected fields survive
          Object.assign(window.__AP_PREFS__, { prefs: data.prefs });
        } else {
          window.__AP_PREFS__ = { customerId: cid, isLoggedIn: true, prefs: data.prefs };
        }
        // Hide the preview mode banner if it's visible
        var banners = document.querySelectorAll('[class*="preview"],[id*="preview"],[data-preview]');
        banners.forEach(function(el) {
          if (el.textContent && el.textContent.toLowerCase().includes('demo data')) {
            el.style.display = 'none';
          }
        });
      })
      .catch(function() {});
  }

  // Run after Shopify's storefront.js has had time to set window.Shopify.customer
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { setTimeout(tryRecover, 600); });
  } else {
    setTimeout(tryRecover, 600);
  }
})();









/* __AP_REORDER_SECTIONS__ */
/* __AP_REORDER_SECTIONS_V10__ */
(function apReorderSections() {
  // 7 content sections in the shuffle pool — including kit and seasonal.
  // 'seasonal' is only in the DOM when any_season is true; querySelector
  // returns null if absent and is skipped gracefully.
  var POOL = ['kit', 'flash', 'rise', 'trending', 'inspiration', 'community', 'seasonal'];

  var order = window.__AP_SECTION_ORDER__;

  if (order === 'random') {
    var pool = POOL.slice();
    for (var i = pool.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = pool[i]; pool[i] = pool[j]; pool[j] = t;
    }
    order = pool;
  } else if (Array.isArray(order)) {
    // Admin-pinned order — keep only POOL keys, append any missing ones at end
    order = order.filter(function(k) { return POOL.indexOf(k) !== -1; });
    POOL.forEach(function(k) { if (order.indexOf(k) === -1) order.push(k); });
  } else {
    return;
  }

  if (!order.length) return;

  // Fallback: if DOMContentLoaded never fires or something throws, reveal all
  // sections after 600ms so the page is never permanently blank.
  function revealSections() {
    var s = document.getElementById('ap-sections-loading');
    if (s && s.parentNode) s.parentNode.removeChild(s);
    var els = document.querySelectorAll('.ap-root [data-section]');
    for (var i = 0; i < els.length; i++) els[i].style.opacity = '1';
  }
  var _revealFallback = setTimeout(revealSections, 600);

  document.addEventListener('DOMContentLoaded', function () {
    clearTimeout(_revealFallback);

    var root = document.querySelector('.ap-root');
    if (!root) { revealSections(); return; }

    // Make ap-root a flex column so CSS order property takes effect.
    // Confirmed safe: no floats, no direct-child selectors, all children
    // are plain block elements that stack fine as flex items.
    root.style.display = 'flex';
    root.style.flexDirection = 'column';

    // Assign order values starting at 100. Non-pool elements keep the
    // default order:0 so they always appear above the shuffled sections.
    // Zero out margin-top on the first section only (i===0): each section
    // type has a different CSS margin-top, so the first one in the shuffled
    // order would otherwise produce a variable-height gap after the search bar.
    order.forEach(function(key, i) {
      var el = document.querySelector('[data-section="' + key + '"]');
      if (el) {
        el.style.order = 100 + i;
        if (i === 0) el.style.marginTop = '0';
      }
    });

    // Pref sections (workouts + sizing): move to the very bottom (order 200+)
    // once the user has already saved those preferences so returning users see
    // content first. New users (prefs not yet set) keep order:0 so the setup
    // prompt appears at the top before the product sections.
    var prefs       = window.__AP_PREFS__ && window.__AP_PREFS__.prefs;
    var workoutsSet = prefs && Array.isArray(prefs.workouts) && prefs.workouts.length > 0;
    var sizingObj   = prefs && prefs.sizing;
    var sizingSet   = sizingObj && Object.keys(sizingObj).some(function(k) { return sizingObj[k]; });

    var workoutsEl = document.querySelector('[data-section="workouts"]');
    var sizingEl   = document.querySelector('[data-section="sizing"]');
    if (workoutsEl && workoutsSet) workoutsEl.style.order = 200;
    if (sizingEl   && sizingSet)   sizingEl.style.order   = 201;

    // Reveal sections now that order is finalised.
    // Remove the hiding <style> injected by the Liquid, then fade in.
    var loadingStyle = document.getElementById('ap-sections-loading');
    if (loadingStyle && loadingStyle.parentNode) {
      loadingStyle.parentNode.removeChild(loadingStyle);
    }
    var sectionEls = root.querySelectorAll('[data-section]');
    for (var i = 0; i < sectionEls.length; i++) {
      sectionEls[i].style.transition = 'opacity 0.15s';
      sectionEls[i].style.opacity = '1';
    }
  });
})();









/* __AP_OPTIN_DATE_GATE_V1__ */
(function apPatchOptinStrips() {
  // Wait until DOMContentLoaded so apApplyOptinStrips is defined, then replace it.
  document.addEventListener('DOMContentLoaded', function() {
    // __AP_ACTIVE_SEASONS__ is injected by the Liquid using server-side date
    // variables (show_mday, show_fday, show_vday). If absent, fall back to
    // allowing all seasons so the behaviour degrades gracefully.
    var activeSeasonsRaw = window.__AP_ACTIVE_SEASONS__;
    var activeSeasons = Array.isArray(activeSeasonsRaw) ? activeSeasonsRaw : null;

    if (typeof apApplyOptinStrips === 'function' && activeSeasons) {
      var _origApplyOptinStrips = apApplyOptinStrips;
      window.apApplyOptinStrips = function(optins) {
        document.querySelectorAll('.seasonal-strip[data-season]').forEach(function(strip) {
          var season = strip.dataset.season;
          // Show only if user opted in AND season is currently in-window
          strip.style.display = (optins && optins[season] && activeSeasons.indexOf(season) !== -1) ? '' : 'none';
        });
        document.querySelectorAll('#apSeasonalChips .occ-chip').forEach(function(c) {
          if (optins && optins[c.dataset.season]) c.classList.add('on');
          else c.classList.remove('on');
        });
      };
      // Re-run immediately to hide any strips wrongly shown on load
      var prefs = (window.__AP_PREFS__ && window.__AP_PREFS__.prefs) || {};
      window.apApplyOptinStrips(prefs.seasonal && prefs.seasonal.optins || {});
    }
  });
})();


/* __AP_PROPOSAL_SUBMIT_GUARD_V1__ */
(function apPatchProposalSubmit() {
  document.addEventListener('DOMContentLoaded', function () {
    var btn = document.querySelector('.prop-btn[onclick*="apSubmitProposal"]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      // Disable immediately so a second tap while the network request is in
      // flight cannot fire a duplicate submission.
      btn.disabled = true;
      btn.style.opacity = '0.6';
      btn.textContent = 'Sending…';
    }, { once: true });
  });
})();


;(function _apPunchCards() {
  var RYE = 'https://paceline-rye-production.up.railway.app';
  var prefs = window.__AP_PREFS__ || {};
  if (!prefs.isPPlus || !prefs.customerId) return;

  var anchor = document.querySelector('.ap-sec');
  if (!anchor) return;

  var sec = document.createElement('div');
  sec.className = 'ap-sec ap-punch-sec';
  sec.innerHTML = '<div class="sec-hd"><span class="sec-eye">LOYALTY REWARDS</span><span class="sec-title">Punch Card</span></div><div class="ap-punch-loading">Loading your rewards...</div>';
  anchor.parentNode.insertBefore(sec, anchor);

  fetch(RYE + '/api/punch-cards?customerId=' + prefs.customerId)
    .then(function(r) { return r.json(); })
    .then(function(data) {
      if (!data.eligible || !data.cards || !data.cards.length) {
        sec.style.display = 'none';
        return;
      }
      var grid = document.createElement('div');
      grid.className = 'ap-punch-grid';

      data.cards.forEach(function(card) {
        var el = document.createElement('div');
        el.className = 'ap-punch-card' + (card.completed ? ' ap-punch-complete' : '');

        var dots = '';
        for (var i = 0; i < card.n; i++) {
          dots += '<span class="ap-dot' + (i < card.progress ? ' filled' : '') + '"></span>';
        }

        var imgSrc = card.image ? card.image.replace(/\.([a-z]+)\?/, '_120x.$1?') : '';
        var action = '';
        if (card.completed) {
          action = '<button class="ap-punch-claim" data-pid="' + card.productId + '">Claim Free Item</button>';
        } else {
          action = '<span class="ap-punch-count">' + card.progress + ' of ' + card.n + '</span>';
        }

        el.innerHTML =
          '<div class="ap-punch-top">' +
            (imgSrc ? '<img src="' + imgSrc + '" alt="" class="ap-punch-img">' : '') +
            '<div class="ap-punch-info">' +
              '<span class="ap-punch-vendor">' + card.vendor + '</span>' +
              '<span class="ap-punch-title">' + card.title + '</span>' +
            '</div>' +
          '</div>' +
          '<div class="ap-punch-dots">' + dots + '</div>' +
          '<div class="ap-punch-bottom">' + action + '</div>';
        grid.appendChild(el);
      });

      var loading = sec.querySelector('.ap-punch-loading');
      if (loading) loading.remove();
      sec.appendChild(grid);

      sec.addEventListener('click', function(e) {
        var btn = e.target.closest('.ap-punch-claim');
        if (!btn || btn.disabled) return;
        btn.disabled = true;
        btn.textContent = 'Claiming...';
        var pid = btn.getAttribute('data-pid');
        fetch(RYE + '/api/punch-cards/claim', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ customerId: prefs.customerId, productId: pid }),
        })
        .then(function(r) { return r.json(); })
        .then(function(result) {
          if (result.success) {
            var cardEl = btn.closest('.ap-punch-card');
            var bottom = cardEl.querySelector('.ap-punch-bottom');
            var exp = new Date(result.expiresAt);
            var expStr = exp.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
            bottom.innerHTML =
              '<div class="ap-punch-code-wrap">' +
                '<span class="ap-punch-code-label">Your code</span>' +
                '<span class="ap-punch-code" onclick="navigator.clipboard.writeText(this.textContent)">' + result.code + '</span>' +
                '<span class="ap-punch-code-exp">Expires ' + expStr + '</span>' +
              '</div>';
            cardEl.classList.add('ap-punch-claimed');
          } else {
            btn.textContent = result.error || 'Error — try again';
            btn.disabled = false;
          }
        })
        .catch(function() {
          btn.textContent = 'Error — try again';
          btn.disabled = false;
        });
      });
    })
    .catch(function(err) {
      console.warn('[punch-cards]', err);
      sec.style.display = 'none';
    });
})();
